(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const MOBILE_MENU_BREAKPOINT = 989;
  const MOBILE_MENU_CLOSE_DURATION_MS = 420;
  const MOBILE_MENU_LINK_BASE_DELAY_MS = 120;
  const MOBILE_MENU_LINK_STAGGER_MS = 72;
  const MOBILE_MENU_LINK_REVEAL_DURATION_MS = 500;
  const MOBILE_MENU_LINK_REVEAL_BUFFER_MS = 40;
  const SEARCH_PREDICTIVE_DEBOUNCE_MS = 140;

  const getMobileMenus = () => Array.from(document.querySelectorAll('[data-mobile-menu]'));
  const getOpenMobileMenus = () => document.querySelectorAll('[data-mobile-menu][open]');
  const isMobileViewport = () => window.innerWidth <= MOBILE_MENU_BREAKPOINT;
  const mobileMenuScrollStates = new WeakMap();
  const mobileMenuRevealTimers = new WeakMap();
  const mobileMenuCloseTimers = new WeakMap();
  const mobileMenuPendingNavigation = new WeakMap();
  const mobileMenuScriptToggle = new WeakSet();
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchOverlayInput = searchOverlay?.querySelector('[data-search-overlay-input]');
  const searchOverlayResults = searchOverlay?.querySelector('[data-search-overlay-results]');
  const searchOverlaySuggestions = searchOverlay?.querySelector('[data-search-overlay-suggestions]');
  const searchOverlayForm = searchOverlay?.querySelector('[data-search-overlay-form]');
  const searchOverlayInputShell = searchOverlay?.querySelector('.site-search-overlay__input-shell');
  const searchOverlayInner = searchOverlay?.querySelector('.site-search-overlay__inner');
  let predictiveSearchController = null;
  let predictiveSearchTimer = null;
  let searchPlaceholderTimer = null;
  let searchPlaceholderIndex = 0;
  let lockedScrollY = 0;
  let scrollbarCompensation = 0;

  const defaultPlaceholderTitles = [
    'Camber shims',
    'Toe arms',
    'Camber plates',
    'Wheel spacers',
    'Handling package'
  ];
  const SEARCH_PLACEHOLDER_FADE_MS = 180;

  const parsePlaceholderTitles = () => {
    const rawTitles = searchOverlayInputShell?.dataset?.searchPlaceholderTitles || '';
    const parsed = rawTitles
      .split(/\r?\n/)
      .map((item) => item.trim())
      .filter(Boolean);
    return parsed.length ? parsed : defaultPlaceholderTitles;
  };

  const updateSearchPlaceholder = () => {
    if (!searchOverlayInput) return;
    if ((searchOverlayInput.value || '').trim().length > 0) return;
    const titles = parsePlaceholderTitles();
    if (!titles.length) return;
    searchOverlayInput.classList.add('is-placeholder-fading');
    window.setTimeout(() => {
      if (!searchOverlayInput) return;
      searchOverlayInput.placeholder = titles[searchPlaceholderIndex % titles.length];
      searchOverlayInput.classList.remove('is-placeholder-fading');
    }, SEARCH_PLACEHOLDER_FADE_MS);
    searchPlaceholderIndex = (searchPlaceholderIndex + 1) % titles.length;
  };

  const startSearchPlaceholderRotation = () => {
    if (!searchOverlayInput) return;
    updateSearchPlaceholder();
    if (searchPlaceholderTimer) window.clearInterval(searchPlaceholderTimer);
    searchPlaceholderTimer = window.setInterval(updateSearchPlaceholder, 1800);
  };

  const stopSearchPlaceholderRotation = () => {
    if (searchPlaceholderTimer) {
      window.clearInterval(searchPlaceholderTimer);
      searchPlaceholderTimer = null;
    }
  };

  const updateScrollbarCompensation = () => {
    scrollbarCompensation = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    document.documentElement.style.setProperty('--site-scrollbar-compensation', `${scrollbarCompensation}px`);
  };

  const closeSearchOverlay = () => {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-visible');
    document.body.classList.remove('site-search-overlay-open');
    document.documentElement.classList.remove('site-search-overlay-open');
    document.body.style.top = '';
    document.documentElement.style.removeProperty('--site-scrollbar-compensation');
    window.dispatchEvent(
      new CustomEvent('site:search-overlay-toggle', {
        detail: {
          open: false,
          scrollY: lockedScrollY
        }
      })
    );
    window.scrollTo(0, lockedScrollY);
    if (predictiveSearchController) {
      predictiveSearchController.abort();
      predictiveSearchController = null;
    }
    stopSearchPlaceholderRotation();
    window.setTimeout(() => {
      if (!searchOverlay.classList.contains('is-visible')) {
        searchOverlay.hidden = true;
      }
    }, 280);
  };

  const openSearchOverlay = () => {
    if (!searchOverlay) return;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    updateScrollbarCompensation();
    searchOverlay.hidden = false;
    window.requestAnimationFrame(() => {
      searchOverlay.classList.add('is-visible');
    });
    document.body.classList.add('site-search-overlay-open');
    document.documentElement.classList.add('site-search-overlay-open');
    document.body.style.top = `-${lockedScrollY}px`;
    window.dispatchEvent(
      new CustomEvent('site:search-overlay-toggle', {
        detail: {
          open: true,
          scrollY: lockedScrollY
        }
      })
    );
    startSearchPlaceholderRotation();
    window.setTimeout(() => {
      searchOverlayInput?.focus();
      searchOverlayInput?.select();
    }, 20);
  };

  const renderPredictiveSearchResults = (products, query) => {
    if (!searchOverlaySuggestions || !searchOverlayResults) return;

    if (!query) {
      searchOverlaySuggestions.innerHTML = '';
      searchOverlayResults.hidden = true;
      return;
    }

    if (!products.length) {
      searchOverlaySuggestions.innerHTML = '<li class="site-search-overlay__empty">No matching products found.</li>';
      searchOverlayResults.hidden = false;
      return;
    }

    const normalizedQuery = String(query || '').trim().toLowerCase();
    const strictPartSearch = /[a-z]{1,4}-[a-z0-9-]+/i.test(normalizedQuery);
    const filteredProducts = strictPartSearch
      ? products.filter((product) => {
          const title = String(product.title || '').toLowerCase();
          const handle = String(product.handle || '').toLowerCase();
          return title.includes(normalizedQuery) || handle.includes(normalizedQuery);
        })
      : products;
    const renderedProducts = filteredProducts.length ? filteredProducts : products;

    searchOverlaySuggestions.innerHTML = renderedProducts
      .map((product) => `<li><a href="${product.url}">${product.title}</a></li>`)
      .join('');
    searchOverlayResults.hidden = false;
  };

  const requestPredictiveSearch = async (query) => {
    if (!searchOverlayInput || !searchOverlaySuggestions || !searchOverlayResults) return;

    const trimmedQuery = query.trim();
    if (!trimmedQuery) {
      renderPredictiveSearchResults([], '');
      return;
    }

    if (predictiveSearchController) predictiveSearchController.abort();
    predictiveSearchController = new AbortController();

    try {
      const url = `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(trimmedQuery)}&resources[type]=product&resources[limit]=10`;
      const response = await fetch(url, {
        signal: predictiveSearchController.signal,
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);
      const payload = await response.json();
      const products = payload?.resources?.results?.products || [];
      renderPredictiveSearchResults(products, trimmedQuery);
    } catch (error) {
      if (error.name === 'AbortError') return;
      renderPredictiveSearchResults([], trimmedQuery);
    }
  };

  const syncMobileMenuBodyState = () => {
    const hasOpenMenu = getOpenMobileMenus().length > 0;
    document.body.classList.toggle('site-mobile-menu-open', hasOpenMenu);
  };

  const clearMobileMenuSelection = (menu) => {
    if (!menu) return;
    menu.querySelectorAll('.site-header__mobile-menu-link.is-active').forEach((link) => {
      link.classList.remove('is-active');
    });
  };

  const clearMobileMenuRevealTimer = (menu) => {
    if (!menu) return;
    const revealTimer = mobileMenuRevealTimers.get(menu);
    if (revealTimer) {
      window.clearTimeout(revealTimer);
      mobileMenuRevealTimers.delete(menu);
    }
  };

  const clearMobileMenuCloseTimer = (menu) => {
    if (!menu) return;
    const closeTimer = mobileMenuCloseTimers.get(menu);
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      mobileMenuCloseTimers.delete(menu);
    }
  };

  const getMobileMenuLinkRevealDuration = (menu) => {
    const linkCount = menu.querySelectorAll('.site-header__mobile-menu-link').length;
    return (
      MOBILE_MENU_LINK_BASE_DELAY_MS +
      Math.max(0, linkCount - 1) * MOBILE_MENU_LINK_STAGGER_MS +
      MOBILE_MENU_LINK_REVEAL_DURATION_MS +
      MOBILE_MENU_LINK_REVEAL_BUFFER_MS
    );
  };

  const updateMobileMenuSelection = (menu) => {
    if (!menu || !isMobileViewport()) return;
    if (menu.dataset.menuRevealing === 'true' || menu.dataset.menuClosing === 'true') return;
    const scrollElement = menu.querySelector('[data-mobile-menu-scroll]');
    if (!scrollElement) return;

    const links = Array.from(menu.querySelectorAll('.site-header__mobile-menu-link'));
    if (!links.length) return;

    const scrollRect = scrollElement.getBoundingClientRect();
    const centerY = scrollRect.top + scrollRect.height / 2;
    let activeLink = null;
    let minDistance = Number.POSITIVE_INFINITY;

    links.forEach((link) => {
      const rect = link.getBoundingClientRect();
      const linkCenter = rect.top + rect.height / 2;
      const distance = Math.abs(linkCenter - centerY);
      if (distance < minDistance) {
        minDistance = distance;
        activeLink = link;
      }
    });

    links.forEach((link) => {
      link.classList.toggle('is-active', link === activeLink);
    });
  };

  const bindMobileMenuScrollTracking = (menu) => {
    if (!menu || mobileMenuScrollStates.has(menu)) return;
    const scrollElement = menu.querySelector('[data-mobile-menu-scroll]');
    if (!scrollElement) return;

    const state = { rafId: null };

    const scheduleUpdate = () => {
      if (state.rafId) return;
      state.rafId = window.requestAnimationFrame(() => {
        state.rafId = null;
        updateMobileMenuSelection(menu);
      });
    };

    state.scheduleUpdate = scheduleUpdate;
    scrollElement.addEventListener('scroll', scheduleUpdate, { passive: true });
    mobileMenuScrollStates.set(menu, state);
    scheduleUpdate();
  };

  const restartMobileMenuLinkReveal = (menu) => {
    if (!menu || !isMobileViewport()) return;
    menu.dataset.mobileLinksReset = 'true';
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        if (!menu.open || menu.dataset.menuClosing === 'true') return;
        menu.dataset.mobileLinksReset = 'false';
      });
    });
  };

  const queueMobileMenuSelection = (menu) => {
    if (!menu || !isMobileViewport()) return;
    clearMobileMenuRevealTimer(menu);
    clearMobileMenuSelection(menu);
    menu.dataset.menuRevealing = 'true';

    const revealTimer = window.setTimeout(() => {
      mobileMenuRevealTimers.delete(menu);
      if (!menu.open || menu.dataset.menuClosing === 'true') return;
      menu.dataset.menuRevealing = 'false';
      updateMobileMenuSelection(menu);
    }, getMobileMenuLinkRevealDuration(menu));

    mobileMenuRevealTimers.set(menu, revealTimer);
  };

  const openMobileMenu = (menu) => {
    if (!menu || !isMobileViewport()) return;
    clearMobileMenuCloseTimer(menu);
    menu.dataset.menuClosing = 'false';
    if (!menu.open) {
      mobileMenuScriptToggle.add(menu);
      menu.setAttribute('open', '');
    }
    bindMobileMenuScrollTracking(menu);
    restartMobileMenuLinkReveal(menu);
    queueMobileMenuSelection(menu);
    syncMobileMenuBodyState();
  };

  const finalizeMobileMenuClose = (menu) => {
    if (!menu) return;
    clearMobileMenuRevealTimer(menu);
    clearMobileMenuCloseTimer(menu);
    menu.dataset.menuClosing = 'false';
    menu.dataset.menuRevealing = 'false';
    menu.dataset.mobileLinksReset = 'false';
    if (menu.open) {
      mobileMenuScriptToggle.add(menu);
      menu.removeAttribute('open');
    }
    clearMobileMenuSelection(menu);
    syncMobileMenuBodyState();
  };

  const closeMobileMenu = (menu, navigateTo = null) => {
    if (!menu) return;

    if (!isMobileViewport()) {
      finalizeMobileMenuClose(menu);
      if (navigateTo) window.location.assign(navigateTo);
      return;
    }

    clearMobileMenuRevealTimer(menu);
    clearMobileMenuCloseTimer(menu);
    if (navigateTo) mobileMenuPendingNavigation.set(menu, navigateTo);
    menu.dataset.menuRevealing = 'false';
    menu.dataset.menuClosing = 'true';
    if (!menu.open) menu.setAttribute('open', '');
    syncMobileMenuBodyState();

    const closeTimer = window.setTimeout(() => {
      mobileMenuCloseTimers.delete(menu);
      const pendingNavigation = mobileMenuPendingNavigation.get(menu);
      mobileMenuPendingNavigation.delete(menu);
      finalizeMobileMenuClose(menu);
      if (pendingNavigation) window.location.assign(pendingNavigation);
    }, MOBILE_MENU_CLOSE_DURATION_MS);

    mobileMenuCloseTimers.set(menu, closeTimer);
  };

  const closeAllMobileMenus = () => {
    getMobileMenus().forEach((menu) => {
      finalizeMobileMenuClose(menu);
    });
  };

  document.addEventListener('click', (event) => {
    const searchOpenTrigger = event.target.closest('[data-search-overlay-open]');
    if (searchOpenTrigger) {
      event.preventDefault();
      const mobileMenu = searchOpenTrigger.closest('[data-mobile-menu]');
      if (mobileMenu && mobileMenu.open && isMobileViewport()) {
        closeMobileMenu(mobileMenu);
        window.setTimeout(() => {
          openSearchOverlay();
        }, MOBILE_MENU_CLOSE_DURATION_MS);
        return;
      }
      openSearchOverlay();
      return;
    }

    const summary = event.target.closest('.site-header__mobile-menu-toggle');
    if (!summary) return;
    const menu = summary.closest('[data-mobile-menu]');
    if (!menu || !isMobileViewport()) return;

    event.preventDefault();

    if (menu.open && menu.dataset.menuClosing !== 'true') {
      closeMobileMenu(menu);
      return;
    }

    openMobileMenu(menu);
  });

  document.addEventListener('click', (event) => {
    const searchCloseTrigger = event.target.closest('[data-search-overlay-close]');
    if (searchCloseTrigger) {
      event.preventDefault();
      closeSearchOverlay();
      return;
    }

    if (
      searchOverlay &&
      searchOverlay.hidden === false &&
      searchOverlay.classList.contains('is-visible') &&
      searchOverlayInner &&
      !searchOverlayInner.contains(event.target) &&
      !event.target.closest('[data-search-overlay-open]')
    ) {
      closeSearchOverlay();
      return;
    }

    const openMenus = Array.from(getOpenMobileMenus());
    if (!openMenus.length) return;

    let closedAny = false;
    openMenus.forEach((menu) => {
      if (menu.contains(event.target)) return;
      closeMobileMenu(menu);
      closedAny = true;
    });

    if (closedAny) syncMobileMenuBodyState();
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.site-header__mobile-menu-links a');
    if (!link) return;

    const menu = link.closest('[data-mobile-menu]');
    if (!menu || !menu.open || !isMobileViewport()) return;

    if (
      event.defaultPrevented ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      link.target === '_blank'
    ) {
      return;
    }

    event.preventDefault();
    closeMobileMenu(menu, link.href);
  });

  document.addEventListener(
    'toggle',
    (event) => {
      if (!event.target.matches('[data-mobile-menu]')) return;
      const menu = event.target;
      if (mobileMenuScriptToggle.has(menu)) {
        mobileMenuScriptToggle.delete(menu);
        syncMobileMenuBodyState();
        return;
      }
      if (menu.open) {
        if (menu.dataset.menuClosing === 'true') return;
        bindMobileMenuScrollTracking(menu);
        restartMobileMenuLinkReveal(menu);
        queueMobileMenuSelection(menu);
      } else {
        clearMobileMenuRevealTimer(menu);
        clearMobileMenuCloseTimer(menu);
        menu.dataset.menuClosing = 'false';
        menu.dataset.menuRevealing = 'false';
        menu.dataset.mobileLinksReset = 'false';
        clearMobileMenuSelection(menu);
      }
      syncMobileMenuBodyState();
    },
    true
  );

  window.addEventListener('resize', () => {
    if (!isMobileViewport()) {
      closeAllMobileMenus();
      return;
    }

    getOpenMobileMenus().forEach((menu) => {
      updateMobileMenuSelection(menu);
    });
  });

  const stickyHeader = document.querySelector('[data-sticky-header="true"]');
  const stickyHeaderWrapper = stickyHeader?.closest('[id^="shopify-section-group-header-group"], .shopify-section');
  let stickyHeaderRafId = null;
  let stickyHeaderLockedScrollY = null;

  const getStickyHeaderEffectiveScrollY = () => {
    if (Number.isFinite(stickyHeaderLockedScrollY)) {
      return stickyHeaderLockedScrollY;
    }

    if (document.body.classList.contains('site-search-overlay-open')) {
      const lockedBodyTop = Number.parseFloat(document.body.style.top || '0');
      if (Number.isFinite(lockedBodyTop) && lockedBodyTop !== 0) {
        return Math.abs(lockedBodyTop);
      }
    }

    return window.scrollY || window.pageYOffset || 0;
  };

  const updateStickyHeaderState = () => {
    stickyHeaderRafId = null;
    if (!stickyHeader || !stickyHeaderWrapper) return;

    const shouldStick = getStickyHeaderEffectiveScrollY() > 0;
    document.documentElement.style.setProperty('--site-sticky-header-height', `${stickyHeaderWrapper.offsetHeight}px`);
    stickyHeaderWrapper.classList.toggle('site-header-group--stuck', shouldStick);
    document.body.classList.toggle('site-header-sticky-active', shouldStick);
  };

  const requestStickyHeaderUpdate = () => {
    if (stickyHeaderRafId) return;
    stickyHeaderRafId = window.requestAnimationFrame(updateStickyHeaderState);
  };

  updateStickyHeaderState();
  window.addEventListener('scroll', requestStickyHeaderUpdate, { passive: true });
  window.addEventListener('resize', requestStickyHeaderUpdate);
  window.addEventListener('site:search-overlay-toggle', (event) => {
    const detail = event?.detail || {};
    stickyHeaderLockedScrollY = detail.open ? Number(detail.scrollY || 0) : null;
    requestStickyHeaderUpdate();
  });

  searchOverlayForm?.addEventListener('submit', () => {
    closeSearchOverlay();
  });

  searchOverlayInput?.addEventListener('input', (event) => {
    const value = event.target.value || '';
    if (value.trim().length > 0) {
      stopSearchPlaceholderRotation();
    } else {
      startSearchPlaceholderRotation();
    }
    if (predictiveSearchTimer) window.clearTimeout(predictiveSearchTimer);
    predictiveSearchTimer = window.setTimeout(() => {
      requestPredictiveSearch(value);
    }, SEARCH_PREDICTIVE_DEBOUNCE_MS);
  });

  searchOverlayInput?.addEventListener('focus', () => {
    if ((searchOverlayInput.value || '').trim().length === 0) {
      startSearchPlaceholderRotation();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && searchOverlay && searchOverlay.hidden === false) {
      closeSearchOverlay();
    }
  });

  syncMobileMenuBodyState();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-builder-strip"] && !Shopify.designMode) return;
  try {
    
  class HomeBuilderForm {
    constructor(formElement) {
      this.form = formElement;
      this.section = this.form.closest('[data-home-builder]');
      this.submitUrl = this.form.dataset.submitUrl;
      this.currency = this.section?.dataset.builderCurrency || 'GBP';
      this.dropdownSource = this.section?.dataset.dropdownSource || 'rules';
      this.locale = document.documentElement.lang || 'en-GB';
      this.routeRoot = window?.Shopify?.routes?.root || '/';

      this.resultsShell = this.section.querySelector('[data-builder-results-shell]');
      this.resultElement = this.section.querySelector('[data-builder-result]');
      this.statusElement = this.section.querySelector('[data-builder-status]');
      this.kitWrapElement = this.section.querySelector('[data-builder-kit-wrap]');
      this.noMatchElement = this.section.querySelector('[data-builder-no-match]');
      this.kitTitleElement = this.section.querySelector('[data-builder-kit-title]');
      this.kitDescriptionElement = this.section.querySelector('[data-builder-kit-description]');
      this.kitItemsElement = this.section.querySelector('[data-builder-kit-items]');
      this.subtotalElement = this.section.querySelector('[data-builder-subtotal]');
      this.totalElement = this.section.querySelector('[data-builder-total]');
      this.feedbackElement = this.section.querySelector('[data-builder-feedback]');
      this.addSelectedButton = this.section.querySelector('[data-builder-add-selected]');
      this.submitButton = this.form.querySelector('[data-builder-submit]');
      this.resetButton = this.form.querySelector('[data-builder-reset]');
      this.selectionMessageElement = this.form.querySelector('[data-builder-selection-message]');
      this.savingsRowElement = this.section.querySelector('[data-builder-savings-row]');
      this.savingsElement = this.section.querySelector('[data-builder-savings]');
      this.savingsMessageElement = this.section.querySelector('[data-builder-savings-message]');

      this.selectMake = this.form.querySelector('select[name="make"]');
      this.selectModel = this.form.querySelector('select[name="model"]');
      this.selectUsage = this.form.querySelector('select[name="usage"]');
      this.selectBudget = this.form.querySelector('select[name="budget"]');
      this.manualUsageOptions = this.getOptionItemsFromSelect(this.selectUsage);
      this.manualBudgetOptions = this.getOptionItemsFromSelect(this.selectBudget);
      this.usageSlider = this.form.querySelector('[data-builder-usage-slider]');
      this.budgetSlider = this.form.querySelector('[data-builder-budget-slider]');
      this.usageValueElement = this.form.querySelector('[data-builder-usage-value]');
      this.budgetValueElement = this.form.querySelector('[data-builder-budget-value]');
      this.sliderOptions = {
        usage: [],
        budget: []
      };
      this.fixedUsageScale = ['Road', 'Mostly Road', 'Road & Track', 'Mostly Track', 'Track'];
      this.fixedUsageScaleNormalized = this.fixedUsageScale.map((label) => this.normalizeValue(label));
      this.fixedBudgetMin = 0;
      this.fixedBudgetMax = 20000;
      this.fixedBudgetStep = 500;
      this.baseBudgetCurrency = 'GBP';
      this.presentmentCurrencyRate = this.getPresentmentCurrencyRate();

      this.moneyFormatter = this.createMoneyFormatter();
      this.rules = this.parseRules();
      this.currentMatch = null;
      this.lastSubmissionQueryKey = '';
      this.isSubmitting = false;
      this.autoBuildTimer = null;
      this.setupRuleDrivenDropdowns();
      this.setupSliderFields();
      this.setupMakeModelDependency();
      this.updateNativeSelectStates();

      if (this.dropdownSource == 'rules' && this.rules.length) {
        this.refreshDependentOptions('make');
      } else {
        this.updateAvailabilityForManualMode();
      }

      this.selectMake?.addEventListener('change', () => {
        this.updateNativeSelectStates();
      });

      this.selectModel?.addEventListener('change', () => {
        this.updateNativeSelectStates();
      });

      this.form.addEventListener('input', () => {
        this.setSelectionMessage('');
      });

      this.form.addEventListener('change', () => {
        this.setSelectionMessage('');
      });

      this.form.addEventListener('submit', this.handleSubmit.bind(this));
      if (this.addSelectedButton) {
        this.addSelectedButton.addEventListener('click', this.handleAddSelected.bind(this));
      }
      if (this.resetButton) {
        this.resetButton.addEventListener('click', this.handleReset.bind(this));
      }
    }

    createMoneyFormatter() {
      try {
        return new Intl.NumberFormat(this.locale, {
          style: 'currency',
          currency: this.currency
        });
      } catch (error) {
        return new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: 'GBP'
        });
      }
    }

    getPresentmentCurrencyRate() {
      const shopifyRate = Number.parseFloat(window?.Shopify?.currency?.rate || '1');
      if (Number.isFinite(shopifyRate) && shopifyRate > 0) {
        return shopifyRate;
      }
      return 1;
    }

    convertBaseCentsToPresentmentCents(baseCents) {
      const baseAmount = Number.isFinite(baseCents) ? baseCents : 0;
      const converted = baseAmount * this.presentmentCurrencyRate;
      return Math.max(0, Math.round(converted));
    }

    parseRules() {
      const rulesScript = this.section.querySelector('[data-builder-rules]');
      if (!rulesScript) return [];

      try {
        const parsed = JSON.parse(rulesScript.textContent || '[]');
        if (!Array.isArray(parsed)) return [];

        return parsed
          .filter((rule) => rule && Array.isArray(rule.items) && rule.items.length > 0)
          .map((rule) => {
            const normalizedItems = rule.items
              .filter((item) => item && item.variantId)
              .map((item) => ({
                ...item,
                variantId: Number.parseInt(item.variantId, 10),
                priceCents: Number.parseInt(item.priceCents || 0, 10),
                available: Boolean(item.available)
              }))
              .filter((item) => Number.isFinite(item.variantId) && item.variantId > 0);

            const individualTotalCents = Number.isFinite(Number.parseInt(rule.individualTotalCents, 10))
              ? Number.parseInt(rule.individualTotalCents, 10)
              : normalizedItems.reduce((sum, item) => sum + (item.priceCents || 0), 0);

            const kitVariantId = Number.parseInt(rule?.kitProduct?.variantId || 0, 10);
            const kitPriceCents = Number.parseInt(rule?.kitProduct?.priceCents || 0, 10);
            const rawKitAvailability = rule?.kitProduct?.available;
            const kitAvailable =
              typeof rawKitAvailability == 'boolean'
                ? rawKitAvailability
                : String(rawKitAvailability || '').toLowerCase() != 'false';
            const budgetMinCents = this.parseBudgetCents(rule.budgetMinRaw);
            const budgetMaxCents = this.parseBudgetCents(rule.budgetMaxRaw);
            const hasBudgetRange = Number.isFinite(budgetMinCents) && Number.isFinite(budgetMaxCents) && budgetMaxCents >= budgetMinCents;
            const rawBudgetLabel = String(rule.budgetLabel || '').trim();
            const budgetLabel = this.buildBudgetLabel(budgetMinCents, budgetMaxCents, rawBudgetLabel);
            const budgetKey = this.buildBudgetKey(budgetMinCents, budgetMaxCents, budgetLabel);

            return {
              ...rule,
              makeLabel: String(rule.make || '').trim(),
              modelLabel: String(rule.model || '').trim(),
              usageLabel: String(rule.usage || '').trim(),
              budgetLabel,
              budgetMinCents: hasBudgetRange ? budgetMinCents : null,
              budgetMaxCents: hasBudgetRange ? budgetMaxCents : null,
              budgetKey,
              make: this.normalizeValue(rule.make),
              model: this.normalizeValue(rule.model),
              usage: this.normalizeValue(rule.usage),
              items: normalizedItems,
              individualTotalCents,
              kitProduct: {
                title: rule?.kitProduct?.title || '',
                url: rule?.kitProduct?.url || '',
                variantId: Number.isFinite(kitVariantId) ? kitVariantId : 0,
                priceCents: Number.isFinite(kitPriceCents) ? kitPriceCents : 0,
                available: kitAvailable
              }
            };
          })
          .filter((rule) => rule.items.length > 0 && rule.make && rule.model && rule.usage);
      } catch (error) {
        return [];
      }
    }

    normalizeValue(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[–—]/g, '-')
        .replace(/£/g, '')
        .replace(/,/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    parseBudgetCents(value) {
      if (value === null || value === undefined) return Number.NaN;

      if (typeof value == 'number' && Number.isFinite(value)) {
        return Math.round(value * 100);
      }

      const raw = String(value).trim();
      if (!raw) return Number.NaN;

      const cleaned = raw.replace(/[^\d,.\-]/g, '');
      if (!cleaned) return Number.NaN;

      let normalized = cleaned;
      if (cleaned.includes(',') && cleaned.includes('.')) {
        normalized = cleaned.replace(/,/g, '');
      } else if (cleaned.includes(',') && !cleaned.includes('.')) {
        normalized = cleaned.replace(/,/g, '');
      }

      normalized = normalized.replace(/(?!^)-/g, '');
      const parsed = Number.parseFloat(normalized);
      if (!Number.isFinite(parsed)) return Number.NaN;

      return Math.round(parsed * 100);
    }

    buildBudgetLabel(minCents, maxCents, fallbackLabel = '') {
      const fallback = String(fallbackLabel || '').trim();
      if (fallback) return fallback;

      const hasMin = Number.isFinite(minCents);
      const hasMax = Number.isFinite(maxCents);

      if (hasMin && hasMax) {
        return `${this.formatMoney(minCents)} - ${this.formatMoney(maxCents)}`;
      }

      if (hasMin) {
        return `From ${this.formatMoney(minCents)}`;
      }

      if (hasMax) {
        return `Up to ${this.formatMoney(maxCents)}`;
      }

      return '';
    }

    buildBudgetKey(minCents, maxCents, label) {
      if (Number.isFinite(minCents) && Number.isFinite(maxCents) && maxCents >= minCents) {
        return `${minCents}-${maxCents}`;
      }

      return this.normalizeValue(label);
    }

    isPlaceholder(value) {
      return this.normalizeValue(value) == '';
    }

    updateNativeSelectState(selectElement) {
      if (!selectElement || !selectElement.classList.contains('home-builder__native-select')) return;
      selectElement.classList.toggle('is-placeholder', this.isPlaceholder(selectElement.value));
    }

    updateNativeSelectStates() {
      this.updateNativeSelectState(this.selectMake);
      this.updateNativeSelectState(this.selectModel);
    }

    getSelections() {
      const formData = new FormData(this.form);
      const rawUsageValue = String(formData.get('usage') || '').trim();
      const rawBudgetValue = String(formData.get('budget') || '').trim();
      const parsedBudgetCents = Number.parseInt(rawBudgetValue, 10);

      return {
        make: this.normalizeValue(formData.get('make')),
        model: this.normalizeValue(formData.get('model')),
        usage: this.normalizeValue(rawUsageValue),
        usageLabel: rawUsageValue,
        budgetKey: this.normalizeValue(rawBudgetValue),
        budgetCents: Number.isFinite(parsedBudgetCents) ? parsedBudgetCents : null
      };
    }

    formatMoney(cents) {
      const normalizedCents = Number.isFinite(cents) ? cents : 0;
      return this.moneyFormatter.format(normalizedCents / 100);
    }

    setStatus(message = '') {
      if (!this.statusElement) return;
      this.statusElement.textContent = message;
      this.statusElement.hidden = message == '';
    }

    setSelectionMessage(message = '') {
      if (!this.selectionMessageElement) return;
      this.selectionMessageElement.textContent = message;
      this.selectionMessageElement.hidden = message == '';
    }

    getMissingSliderMessage(selections) {
      const usageMissing = this.isPlaceholder(selections?.usage);
      const budgetMissing = !Number.isFinite(selections?.budgetCents);

      if (usageMissing && budgetMissing) {
        return 'Please select your usage and budget.';
      }

      if (usageMissing) {
        return 'Please select your usage.';
      }

      if (budgetMissing) {
        return 'Please select your budget.';
      }

      return '';
    }

    setFeedback(message, type = 'info') {
      if (!this.feedbackElement) return;
      this.feedbackElement.textContent = message || '';
      this.feedbackElement.dataset.state = type;
    }

    uniqueLabels(values) {
      const seen = new Set();
      const ordered = [];

      values.forEach((value) => {
        const label = String(value || '').trim();
        if (!label) return;
        const normalized = this.normalizeValue(label);
        if (!normalized || seen.has(normalized)) return;
        seen.add(normalized);
        ordered.push(label);
      });

      ordered.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
      return ordered;
    }

    uniqueOptionItems(items) {
      const seen = new Set();
      const unique = [];

      items.forEach((item) => {
        if (!item) return;
        const label = String(item.label || '').trim();
        const value = String(item.value || '').trim();
        if (!label || !value || seen.has(value)) return;
        seen.add(value);
        unique.push({
          label,
          value,
          sortKey: Number.isFinite(item.sortKey) ? item.sortKey : null
        });
      });

      unique.sort((a, b) => {
        const aHasNumeric = Number.isFinite(a.sortKey);
        const bHasNumeric = Number.isFinite(b.sortKey);
        if (aHasNumeric && bHasNumeric) return a.sortKey - b.sortKey;
        return a.label.localeCompare(b.label, undefined, { sensitivity: 'base' });
      });

      return unique;
    }

    getFixedUsageOptionItems() {
      return this.fixedUsageScale.map((scaleLabel) => ({
        label: scaleLabel,
        value: scaleLabel
      }));
    }

    getFixedBudgetOptionItems() {
      const options = [];
      const seenValues = new Set();

      for (let pounds = this.fixedBudgetMin; pounds <= this.fixedBudgetMax; pounds += this.fixedBudgetStep) {
        const baseCents = pounds * 100;
        const cents = this.convertBaseCentsToPresentmentCents(baseCents);
        if (seenValues.has(cents)) continue;
        seenValues.add(cents);

        options.push({
          label: this.formatMoney(cents),
          value: String(cents),
          sortKey: cents
        });
      }

      return options;
    }

    getBudgetOptionsForContext(rulesForUsage = [], rulesForModel = []) {
      const fromUsage = this.uniqueOptionItems(
        rulesForUsage.map((rule) => ({
          label: rule.budgetLabel,
          value: rule.budgetKey,
          sortKey: rule.budgetMinCents
        }))
      );
      if (fromUsage.length) return fromUsage;

      const fromModel = this.uniqueOptionItems(
        rulesForModel.map((rule) => ({
          label: rule.budgetLabel,
          value: rule.budgetKey,
          sortKey: rule.budgetMinCents
        }))
      );
      if (fromModel.length) return fromModel;

      if (Array.isArray(this.manualBudgetOptions) && this.manualBudgetOptions.length) {
        return this.manualBudgetOptions;
      }

      return this.uniqueOptionItems(
        this.rules.map((rule) => ({
          label: rule.budgetLabel,
          value: rule.budgetKey,
          sortKey: rule.budgetMinCents
        }))
      );
    }

    writeSelectOptions(selectElement, options, preferredValue = '') {
      if (!selectElement) return;

      const normalizedPreferred = this.normalizeValue(preferredValue);
      const optionsHtml = ['<option value="">Please select</option>']
        .concat(
          options.map((item) => {
            const label = typeof item == 'string' ? item : item.label;
            const value = typeof item == 'string' ? item : item.value;
            const selected = this.normalizeValue(value) == normalizedPreferred ? ' selected' : '';
            return `<option value="${this.escapeHtml(value)}"${selected}>${this.escapeHtml(label)}</option>`;
          })
        )
        .join('');

      selectElement.innerHTML = optionsHtml;
    }

    getOptionItemsFromSelect(selectElement) {
      if (!selectElement) return [];

      return Array.from(selectElement.options)
        .map((option) => ({
          value: String(option.value || '').trim(),
          label: String(option.textContent || '').trim()
        }))
        .filter((option) => !this.isPlaceholder(option.value));
    }

    setSliderFieldValue(type, options, index, preserveSliderPosition = false) {
      const selectElement = type == 'usage' ? this.selectUsage : this.selectBudget;
      const sliderElement = type == 'usage' ? this.usageSlider : this.budgetSlider;
      const valueElement = type == 'usage' ? this.usageValueElement : this.budgetValueElement;

      if (!selectElement || !sliderElement || !valueElement) return;

      if (!options.length) {
        selectElement.value = '';
        sliderElement.value = '0';
        valueElement.textContent = 'Please select';
        return;
      }

      const safeIndex = Math.max(0, Math.min(index, options.length - 1));
      const selectedOption = options[safeIndex];
      if (!preserveSliderPosition) {
        sliderElement.value = String(safeIndex);
      }
      selectElement.value = selectedOption.value;
      valueElement.textContent = selectedOption.label || 'Please select';
    }

    syncSliderWithSelect(type, preferredValue = '') {
      const selectElement = type == 'usage' ? this.selectUsage : this.selectBudget;
      const sliderElement = type == 'usage' ? this.usageSlider : this.budgetSlider;
      const valueElement = type == 'usage' ? this.usageValueElement : this.budgetValueElement;

      if (!selectElement || !sliderElement || !valueElement) return;

      const options = this.getOptionItemsFromSelect(selectElement);
      this.sliderOptions[type] = options;

      sliderElement.min = '0';
      sliderElement.step = '0.01';
      sliderElement.max = options.length > 0 ? String(options.length - 1) : '0';
      sliderElement.disabled = options.length === 0;

      if (!options.length) {
        this.setSliderFieldValue(type, options, 0);
        return;
      }

      const targetValue = String(preferredValue || selectElement.value || '').trim();
      if (this.isPlaceholder(targetValue)) {
        selectElement.value = '';
        sliderElement.value = '0';
        valueElement.textContent = 'Please select';
        return;
      }

      const normalizedTarget = this.normalizeValue(targetValue);
      let targetIndex = options.findIndex((option) => this.normalizeValue(option.value) == normalizedTarget);

      if (targetIndex < 0) {
        targetIndex = 0;
      }

      this.setSliderFieldValue(type, options, targetIndex);
    }

    applySliderSelection(type, shouldRefreshRules = false) {
      const sliderElement = type == 'usage' ? this.usageSlider : this.budgetSlider;
      const options = this.sliderOptions[type] || [];

      if (!sliderElement || !options.length) return;

      const parsedValue = Number.parseFloat(sliderElement.value || '0');
      const safeValue = Number.isFinite(parsedValue) ? Math.max(0, Math.min(parsedValue, options.length - 1)) : 0;
      const safeIndex = Math.max(0, Math.min(Math.round(safeValue), options.length - 1));
      this.setSliderFieldValue(type, options, safeIndex, true);

      if (shouldRefreshRules && this.dropdownSource == 'rules' && type == 'usage') {
        this.refreshDependentOptions('usage', { preserveUsageSliderPosition: true });
      } else if (type == 'usage') {
        this.updateAvailabilityForManualMode();
      }
    }

    setupSliderFields() {
      if (this.dropdownSource != 'rules') {
        const usageScaleOptions = this.getFixedUsageOptionItems();
        this.writeSelectOptions(this.selectUsage, usageScaleOptions, this.selectUsage?.value || '');
      }

      const fixedBudgetOptions = this.getFixedBudgetOptionItems();
      this.writeSelectOptions(this.selectBudget, fixedBudgetOptions, this.selectBudget?.value || '');

      this.syncSliderWithSelect('usage', this.selectUsage?.value || '');
      this.syncSliderWithSelect('budget', this.selectBudget?.value || '');

      this.usageSlider?.addEventListener('input', () => {
        this.applySliderSelection('usage', true);
        this.scheduleAutoBuildFromBudget();
      });

      this.usageSlider?.addEventListener('change', () => {
        this.applySliderSelection('usage', true);
        this.triggerAutoBuildFromBudget();
      });

      this.budgetSlider?.addEventListener('input', () => {
        this.applySliderSelection('budget');
        this.scheduleAutoBuildFromBudget();
      });

      this.budgetSlider?.addEventListener('change', () => {
        this.applySliderSelection('budget');
        this.triggerAutoBuildFromBudget();
      });
    }

    setupMakeModelDependency() {
      if (!this.rules.length || this.dropdownSource == 'rules') return;

      this.selectMake?.addEventListener('change', () => {
        this.refreshModelOptionsByMake();
      });

      this.selectModel?.addEventListener('change', () => {
        this.updateAvailabilityForManualMode();
      });

      this.refreshModelOptionsByMake();
    }

    refreshModelOptionsByMake() {
      if (!this.selectMake || !this.selectModel || !this.rules.length) return;

      const selectedMakeValue = this.selectMake.value || '';
      const previousModelValue = this.selectModel.value || '';
      const make = this.normalizeValue(selectedMakeValue);
      const hasMakeSelected = !this.isPlaceholder(selectedMakeValue);

      this.selectModel.disabled = !hasMakeSelected;
      if (!hasMakeSelected) {
        this.writeSelectOptions(this.selectModel, []);
        this.updateNativeSelectStates();
        this.updateAvailabilityForManualMode();
        return;
      }

      const byMake = this.rules.filter((rule) => !make || rule.make == make);
      const modelOptions = this.uniqueOptionItems(
        byMake.map((rule) => ({
          label: rule.modelLabel,
          value: rule.modelLabel
        }))
      );

      if (!modelOptions.length) return;
      this.writeSelectOptions(this.selectModel, modelOptions, previousModelValue);
      this.updateNativeSelectStates();
      this.updateAvailabilityForManualMode();
    }

    escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    setupRuleDrivenDropdowns() {
      if (this.dropdownSource != 'rules' || !this.rules.length) return;

      const makeOptions = this.uniqueOptionItems(
        this.rules.map((rule) => ({
          label: rule.makeLabel,
          value: rule.makeLabel
        }))
      );
      this.writeSelectOptions(this.selectMake, makeOptions);
      this.writeSelectOptions(this.selectModel, []);
      this.writeSelectOptions(this.selectUsage, []);
      this.writeSelectOptions(this.selectBudget, []);

      this.selectMake?.addEventListener('change', () => {
        this.refreshDependentOptions('make');
      });

      this.selectModel?.addEventListener('change', () => {
        this.refreshDependentOptions('model');
      });

      this.refreshDependentOptions('make');
    }

    updateAvailabilityForManualMode() {
      if (this.dropdownSource == 'rules') return;

      const hasMakeSelected = !this.isPlaceholder(this.selectMake?.value || '');
      const hasModelSelected = !this.isPlaceholder(this.selectModel?.value || '');
      const hasUsageSelected = !this.isPlaceholder(this.selectUsage?.value || '');
      const usageOptions = this.sliderOptions.usage || [];
      const budgetOptions = this.sliderOptions.budget || [];

      const usageShouldEnable = hasMakeSelected && hasModelSelected && usageOptions.length > 0;
      if (!usageShouldEnable) {
        this.selectUsage.value = '';
        this.syncSliderWithSelect('usage', '');
      }
      if (this.usageSlider) {
        this.usageSlider.disabled = !usageShouldEnable;
      }

      const budgetShouldEnable = usageShouldEnable && hasUsageSelected && budgetOptions.length > 0;
      if (!budgetShouldEnable) {
        this.selectBudget.value = '';
        this.syncSliderWithSelect('budget', '');
      }
      if (this.budgetSlider) {
        this.budgetSlider.disabled = !budgetShouldEnable;
      }
    }

    refreshDependentOptions(changedField, options = {}) {
      if (this.dropdownSource != 'rules' || !this.rules.length) return;

      const selectedMakeValue = this.selectMake?.value || '';
      const selectedModelValue = this.selectModel?.value || '';
      const selectedUsageValue = this.selectUsage?.value || '';
      const selectedBudgetValue = this.selectBudget?.value || '';

      const make = this.normalizeValue(selectedMakeValue);
      const hasMakeSelected = !this.isPlaceholder(selectedMakeValue);

      if (this.selectModel) {
        this.selectModel.disabled = !hasMakeSelected;
      }

      if (!hasMakeSelected) {
        this.writeSelectOptions(this.selectModel, []);
        this.writeSelectOptions(this.selectUsage, this.getFixedUsageOptionItems());
        this.writeSelectOptions(this.selectBudget, this.getFixedBudgetOptionItems());
        this.selectUsage.value = '';
        this.selectBudget.value = '';

        if (!options.preserveUsageSliderPosition) {
          this.syncSliderWithSelect('usage', '');
        }
        this.syncSliderWithSelect('budget', '');
        if (this.usageSlider) this.usageSlider.disabled = true;
        if (this.budgetSlider) this.budgetSlider.disabled = true;
        this.updateNativeSelectStates();
        return;
      }

      const byMake = this.rules.filter((rule) => !make || rule.make == make);
      const modelOptions = this.uniqueOptionItems(
        byMake.map((rule) => ({
          label: rule.modelLabel,
          value: rule.modelLabel
        }))
      );
      this.writeSelectOptions(this.selectModel, modelOptions, selectedModelValue);

      const nextModel = this.normalizeValue(this.selectModel?.value || '');
      const hasModelSelected = !this.isPlaceholder(this.selectModel?.value || '');
      const usageOptions = this.getFixedUsageOptionItems();
      this.writeSelectOptions(this.selectUsage, usageOptions, selectedUsageValue);

      if (changedField == 'make') {
        this.selectUsage.value = '';
        this.selectBudget.value = '';
      }

      if (changedField == 'model') {
        this.selectBudget.value = '';
      }

      if (!hasModelSelected) {
        this.selectUsage.value = '';
        this.selectBudget.value = '';
        this.writeSelectOptions(this.selectBudget, this.getFixedBudgetOptionItems());

        if (!options.preserveUsageSliderPosition) {
          this.syncSliderWithSelect('usage', '');
        }
        this.syncSliderWithSelect('budget', '');
        if (this.usageSlider) this.usageSlider.disabled = true;
        if (this.budgetSlider) this.budgetSlider.disabled = true;
        this.updateNativeSelectStates();
        return;
      }

      const hasUsageSelected = !this.isPlaceholder(this.selectUsage?.value || '');
      if (!hasUsageSelected) {
        this.writeSelectOptions(this.selectBudget, this.getFixedBudgetOptionItems());
        this.selectBudget.value = '';

        if (!options.preserveUsageSliderPosition) {
          this.syncSliderWithSelect('usage', this.selectUsage?.value || '');
        }
        this.syncSliderWithSelect('budget', '');
        if (this.usageSlider) this.usageSlider.disabled = false;
        if (this.budgetSlider) this.budgetSlider.disabled = true;
        this.updateNativeSelectStates();
        return;
      }

      const budgetOptions = this.getFixedBudgetOptionItems();
      const preferredBudgetValue = this.isPlaceholder(selectedBudgetValue) ? '' : selectedBudgetValue;
      this.writeSelectOptions(this.selectBudget, budgetOptions, preferredBudgetValue);

      if (!options.preserveUsageSliderPosition) {
        this.syncSliderWithSelect('usage', this.selectUsage?.value || '');
      }
      this.syncSliderWithSelect('budget', this.selectBudget?.value || preferredBudgetValue);
      if (this.usageSlider) this.usageSlider.disabled = false;
      if (this.budgetSlider) this.budgetSlider.disabled = false;
      this.updateNativeSelectStates();
    }

    getRuleBudgetDistance(rule, targetBudgetCents) {
      if (!Number.isFinite(targetBudgetCents)) return Number.POSITIVE_INFINITY;

      const hasMin = Number.isFinite(rule?.budgetMinCents);
      const hasMax = Number.isFinite(rule?.budgetMaxCents);

      if (hasMin && hasMax) {
        if (targetBudgetCents < rule.budgetMinCents) return rule.budgetMinCents - targetBudgetCents;
        if (targetBudgetCents > rule.budgetMaxCents) return targetBudgetCents - rule.budgetMaxCents;
        return 0;
      }

      if (hasMin) {
        return targetBudgetCents < rule.budgetMinCents ? rule.budgetMinCents - targetBudgetCents : 0;
      }

      if (hasMax) {
        return targetBudgetCents > rule.budgetMaxCents ? targetBudgetCents - rule.budgetMaxCents : 0;
      }

      const kitPriceCents = Number.parseInt(rule?.kitProduct?.priceCents || 0, 10);
      if (Number.isFinite(kitPriceCents) && kitPriceCents > 0) {
        return Math.abs(kitPriceCents - targetBudgetCents);
      }

      const individualTotalCents = Number.parseInt(rule?.individualTotalCents || 0, 10);
      if (Number.isFinite(individualTotalCents) && individualTotalCents > 0) {
        return Math.abs(individualTotalCents - targetBudgetCents);
      }

      return Number.POSITIVE_INFINITY;
    }

    getRuleBudgetAnchor(rule) {
      const hasMin = Number.isFinite(rule?.budgetMinCents);
      const hasMax = Number.isFinite(rule?.budgetMaxCents);

      if (hasMin && hasMax) {
        return (rule.budgetMinCents + rule.budgetMaxCents) / 2;
      }

      if (hasMin) return rule.budgetMinCents;
      if (hasMax) return rule.budgetMaxCents;

      const kitPriceCents = Number.parseInt(rule?.kitProduct?.priceCents || 0, 10);
      if (Number.isFinite(kitPriceCents) && kitPriceCents > 0) return kitPriceCents;

      const individualTotalCents = Number.parseInt(rule?.individualTotalCents || 0, 10);
      if (Number.isFinite(individualTotalCents) && individualTotalCents > 0) return individualTotalCents;

      return Number.POSITIVE_INFINITY;
    }

    getRuleUsageDistance(rule, selectedUsage) {
      if (!selectedUsage) return Number.POSITIVE_INFINITY;
      if (rule?.usage == selectedUsage) return 0;

      const selectedIndex = this.fixedUsageScaleNormalized.indexOf(selectedUsage);
      const ruleIndex = this.fixedUsageScaleNormalized.indexOf(rule?.usage || '');
      if (selectedIndex >= 0 && ruleIndex >= 0) {
        return Math.abs(ruleIndex - selectedIndex);
      }

      return 100;
    }

    findMatchingRule(selections) {
      const candidates = this.rules.filter((rule) => {
        return rule.make == selections.make && rule.model == selections.model;
      });

      if (!candidates.length) return null;
      if (!Number.isFinite(selections.budgetCents)) {
        let closestUsage = candidates[0];
        let bestUsageDistance = this.getRuleUsageDistance(closestUsage, selections.usage);

        candidates.slice(1).forEach((rule) => {
          const usageDistance = this.getRuleUsageDistance(rule, selections.usage);
          if (usageDistance < bestUsageDistance) {
            closestUsage = rule;
            bestUsageDistance = usageDistance;
          }
        });

        return closestUsage;
      }

      const budgetStepCents = Math.max(1, this.fixedBudgetStep * 100);
      const usageWeight = 2;
      let bestMatch = candidates[0];
      let bestUsageDistance = this.getRuleUsageDistance(bestMatch, selections.usage);
      let bestDistance = this.getRuleBudgetDistance(bestMatch, selections.budgetCents);
      let bestAnchorOffset = Math.abs(this.getRuleBudgetAnchor(bestMatch) - selections.budgetCents);
      let bestScore = bestUsageDistance * usageWeight + bestDistance / budgetStepCents;

      candidates.slice(1).forEach((rule) => {
        const usageDistance = this.getRuleUsageDistance(rule, selections.usage);
        const distance = this.getRuleBudgetDistance(rule, selections.budgetCents);
        const anchorOffset = Math.abs(this.getRuleBudgetAnchor(rule) - selections.budgetCents);
        const score = usageDistance * usageWeight + distance / budgetStepCents;

        const isBetterScore = score < bestScore;
        const isScoreTieButBetterUsage = score == bestScore && usageDistance < bestUsageDistance;
        const isScoreUsageTieButBetterBudget =
          score == bestScore && usageDistance == bestUsageDistance && distance < bestDistance;
        const isFullTieButBetterAnchor =
          score == bestScore &&
          usageDistance == bestUsageDistance &&
          distance == bestDistance &&
          anchorOffset < bestAnchorOffset;

        if (isBetterScore || isScoreTieButBetterUsage || isScoreUsageTieButBetterBudget || isFullTieButBetterAnchor) {
          bestMatch = rule;
          bestScore = score;
          bestUsageDistance = usageDistance;
          bestDistance = distance;
          bestAnchorOffset = anchorOffset;
        }
      });

      return bestMatch;
    }

    wait(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    }

    clearAutoBuildTimer() {
      if (!this.autoBuildTimer) return;
      window.clearTimeout(this.autoBuildTimer);
      this.autoBuildTimer = null;
    }

    scheduleAutoBuildFromBudget() {
      this.clearAutoBuildTimer();
      this.autoBuildTimer = window.setTimeout(() => {
        this.autoBuildTimer = null;
        this.triggerAutoBuildFromBudget();
      }, 180);
    }

    hasCompleteSelections(selections) {
      return !(
        this.isPlaceholder(selections.make) ||
        this.isPlaceholder(selections.model) ||
        this.isPlaceholder(selections.usage) ||
        !Number.isFinite(selections.budgetCents)
      );
    }

    triggerAutoBuildFromBudget() {
      const selections = this.getSelections();
      if (!this.hasCompleteSelections(selections)) return;
      this.setSelectionMessage('');
      this.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }

    getSubmissionQueryKey(selections) {
      return [selections.make, selections.model, selections.usage, String(selections.budgetCents || '')].join('||');
    }

    async ensureResultsShellVisible({ animate = false } = {}) {
      if (!this.resultsShell) return;

      const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const shouldAnimate = animate && !prefersReducedMotion;

      if (!shouldAnimate) {
        if (this.resultsShell.hidden) {
          this.resultsShell.hidden = false;
        }
        this.resultsShell.classList.remove('is-shell-opening');
        this.resultsShell.classList.remove('is-pre-reveal');
        this.resultsShell.style.maxHeight = 'none';
        this.resultsShell.style.opacity = '';
        return;
      }

      this.resultsShell.classList.add('is-shell-opening');
      this.resultsShell.style.maxHeight = '0px';
      this.resultsShell.style.opacity = '0';
      if (this.resultsShell.hidden) {
        this.resultsShell.hidden = false;
      }
      void this.resultsShell.offsetHeight;

      const targetHeight = Math.max(this.resultsShell.scrollHeight, 60);
      this.resultsShell.style.maxHeight = `${targetHeight}px`;
      this.resultsShell.style.opacity = '1';

      await this.wait(620);
      this.resultsShell.style.maxHeight = 'none';
      this.resultsShell.style.opacity = '';
      this.resultsShell.classList.remove('is-shell-opening');
    }

    async playResultsSwapOutAnimation() {
      if (!this.resultsShell || this.resultsShell.hidden) return;

      const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) return;

      this.resultsShell.classList.add('is-swapping-out');
      await this.wait(280);
    }

    async handleSubmit(event) {
      event.preventDefault();
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      try {
        const selections = this.getSelections();
        const queryKey = this.getSubmissionQueryKey(selections);
        const queryChanged = queryKey != this.lastSubmissionQueryKey;
        const hasInvalidSelection = !this.hasCompleteSelections(selections);
        const wasHidden = this.resultsShell.hidden;
        const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const shouldAnimate = queryChanged && !prefersReducedMotion;

        if (shouldAnimate && wasHidden) {
          this.resultsShell.classList.add('is-pre-reveal');
        } else if (!shouldAnimate) {
          this.resultsShell.classList.remove('is-pre-reveal');
        }

        this.resultElement.hidden = false;
        this.setFeedback('');
        this.setStatus('');
        this.setSelectionMessage('');

        if (!wasHidden && shouldAnimate) {
          await this.playResultsSwapOutAnimation();
          this.resultsShell.classList.add('is-pre-reveal');
        }

        this.resetResultsRevealAnimation();

        if (hasInvalidSelection) {
          this.currentMatch = null;
          this.kitWrapElement.hidden = true;
          this.noMatchElement.hidden = true;
          this.resultElement.hidden = true;
          this.setStatus('');
          this.setSelectionMessage(this.getMissingSliderMessage(selections));
          this.resultsShell.classList.remove('is-revealing', 'is-pre-reveal', 'is-shell-opening', 'is-swapping-out');
          this.resultsShell.style.maxHeight = 'none';
          this.resultsShell.style.opacity = '';
          this.resultsShell.hidden = true;
          this.lastSubmissionQueryKey = queryKey;
          return;
        }

        const matchingRule = this.findMatchingRule(selections);

        if (!matchingRule) {
          const noMatchUnchanged = !queryChanged && !this.currentMatch && !this.noMatchElement.hidden;
          this.currentMatch = null;
          this.kitWrapElement.hidden = true;
          this.noMatchElement.hidden = false;
          this.setStatus('');

          if (this.submitUrl) {
            const separator = this.submitUrl.includes('?') ? '&' : '?';
            const query = new URLSearchParams({
              make: selections.make,
              model: selections.model,
              usage: selections.usage,
              budget_key: selections.budgetKey,
              budget_cents: String(selections.budgetCents || '')
            });
            const fallbackUrl = `${this.submitUrl}${separator}${query.toString()}`;
            const fallbackLink = this.noMatchElement.querySelector('a.home-builder__fallback-link');
            if (fallbackLink && !fallbackLink.dataset.lockedHref) {
              fallbackLink.href = fallbackUrl;
            }
          }

          await this.ensureResultsShellVisible({ animate: wasHidden && shouldAnimate });
          if (!noMatchUnchanged && shouldAnimate) {
            this.playResultsRevealAnimation();
          }
          this.lastSubmissionQueryKey = queryKey;
          return;
        }

        const sameQueryAndSameRule =
          !queryChanged &&
          this.currentMatch &&
          String(this.currentMatch.id || '') == String(matchingRule.id || '') &&
          !this.kitWrapElement.hidden;

        if (sameQueryAndSameRule) {
          this.noMatchElement.hidden = true;
          this.kitWrapElement.hidden = false;
          await this.ensureResultsShellVisible({ animate: false });
          this.lastSubmissionQueryKey = queryKey;
          return;
        }

        this.currentMatch = matchingRule;
        this.noMatchElement.hidden = true;
        this.kitWrapElement.hidden = false;
        this.renderMatch(matchingRule, {
          animate: false,
          selectedUsage: selections.usage
        });
        await this.ensureResultsShellVisible({ animate: wasHidden && shouldAnimate });
        if (shouldAnimate) {
          this.playResultsRevealAnimation();
        }
        this.lastSubmissionQueryKey = queryKey;
      } finally {
        this.isSubmitting = false;
      }
    }

    hideResultsShell() {
      if (!this.resultsShell) return;
      this.resultsShell.hidden = true;
      this.resultsShell.classList.remove('is-revealing', 'is-pre-reveal', 'is-shell-opening', 'is-swapping-out');
      this.resultsShell.style.maxHeight = 'none';
      this.resultsShell.style.opacity = '';
    }

    handleReset() {
      this.clearAutoBuildTimer();
      this.form.reset();
      this.currentMatch = null;
      this.lastSubmissionQueryKey = '';
      if (this.selectUsage) this.selectUsage.value = '';
      if (this.selectBudget) this.selectBudget.value = '';

      if (this.dropdownSource == 'rules' && this.rules.length) {
        this.refreshDependentOptions('make');
      } else {
        this.syncSliderWithSelect('usage', '');
        this.syncSliderWithSelect('budget', '');
        this.updateAvailabilityForManualMode();
      }

      this.updateNativeSelectStates();
      this.setSelectionMessage('');
      this.setStatus('');
      this.setFeedback('');

      if (this.resultElement) this.resultElement.hidden = true;
      if (this.kitWrapElement) this.kitWrapElement.hidden = true;
      if (this.noMatchElement) this.noMatchElement.hidden = true;
      this.hideResultsShell();
    }

    renderMatch(rule, options = {}) {
      const animate = options.animate !== false;
      const selectedUsage = this.normalizeValue(options.selectedUsage || '');
      const matchedUsage = this.normalizeValue(rule.usage || '');
      const hasUsageFallback = selectedUsage && matchedUsage && selectedUsage != matchedUsage;
      const usageLabel = String(rule.usageLabel || rule.usage || '').trim();
      const baseTitle = rule.title || 'Recommended kit';
      this.kitTitleElement.textContent = hasUsageFallback && usageLabel ? `${baseTitle} (${usageLabel})` : baseTitle;
      this.kitDescriptionElement.textContent = rule.description || '';
      this.kitDescriptionElement.hidden = !rule.description;

      this.kitItemsElement.innerHTML = '';

      rule.items.forEach((item, index) => {
        const card = this.createItemCard(item);
        card.style.setProperty('--builder-reveal-index', String(index));
        this.kitItemsElement.appendChild(card);
      });

      this.kitItemsElement.querySelectorAll('[data-builder-item-toggle]').forEach((toggle) => {
        toggle.addEventListener('change', () => {
          this.updateSummary();
        });
      });

      this.updateSummary();
      if (animate) {
        this.playResultsRevealAnimation();
      }
    }

    resetResultsRevealAnimation() {
      if (!this.resultsShell) return;
      this.resultsShell.classList.remove('is-revealing');
      this.resultsShell.classList.remove('is-swapping-out');
    }

    playResultsRevealAnimation() {
      if (!this.resultsShell) return;

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.resultsShell.classList.remove('is-revealing');
        this.resultsShell.classList.remove('is-pre-reveal');
        return;
      }
      this.resultsShell.classList.remove('is-revealing');
      void this.resultsShell.offsetWidth;
      this.resultsShell.classList.add('is-revealing');
      requestAnimationFrame(() => {
        if (!this.resultsShell) return;
        this.resultsShell.classList.remove('is-pre-reveal');
      });
    }

    createItemCard(item) {
      const card = document.createElement('article');
      card.className = 'home-builder-kit__item';
      card.dataset.builderKitCard = 'true';
      card.dataset.variantId = String(item.variantId || '');
      card.dataset.priceCents = String(item.priceCents || 0);
      card.dataset.available = item.available ? 'true' : 'false';

      const mediaLink = document.createElement('a');
      mediaLink.className = 'home-builder-kit__media';
      mediaLink.href = item.url || '#';
      mediaLink.setAttribute('aria-label', item.title || 'Kit item');

      if (item.image) {
        const image = document.createElement('img');
        image.className = 'home-builder-kit__image home-builder-kit__image--primary';
        image.src = item.image;
        image.alt = item.title || 'Kit item image';
        image.loading = 'lazy';
        mediaLink.appendChild(image);

        if (item.hoverImage && item.hoverImage != item.image) {
          const hoverImage = document.createElement('img');
          hoverImage.className = 'home-builder-kit__image home-builder-kit__image--hover';
          hoverImage.src = item.hoverImage;
          hoverImage.alt = item.title || 'Kit item alternate image';
          hoverImage.loading = 'lazy';
          mediaLink.appendChild(hoverImage);
        }
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'home-builder-kit__placeholder';
        mediaLink.appendChild(placeholder);
      }

      const info = document.createElement('div');
      info.className = 'home-builder-kit__info';

      const titleLink = document.createElement('a');
      titleLink.className = 'home-builder-kit__title';
      titleLink.href = item.url || '#';
      titleLink.textContent = item.title || 'Item';

      const price = document.createElement('p');
      price.className = 'home-builder-kit__price';
      price.textContent = this.formatMoney(item.priceCents || 0);

      const toggleLabel = document.createElement('label');
      toggleLabel.className = 'home-builder-kit__toggle';
      toggleLabel.title = item.available ? 'Include item' : 'Unavailable';

      const toggle = document.createElement('input');
      toggle.type = 'checkbox';
      toggle.dataset.builderItemToggle = 'true';
      toggle.checked = item.available;
      toggle.disabled = !item.available;
      toggle.setAttribute(
        'aria-label',
        item.available ? `Include ${item.title || 'item'}` : `${item.title || 'Item'} unavailable`
      );

      const toggleText = document.createElement('span');
      toggleText.className = 'home-builder-kit__toggle-text';
      toggleText.textContent = item.available ? 'Include' : 'Unavailable';

      toggleLabel.appendChild(toggle);
      toggleLabel.appendChild(toggleText);

      info.appendChild(titleLink);
      info.appendChild(price);

      card.appendChild(toggleLabel);
      card.appendChild(mediaLink);
      card.appendChild(info);
      return card;
    }

    updateSummary() {
      const cards = Array.from(this.kitItemsElement.querySelectorAll('[data-builder-kit-card="true"]'));
      let selectedTotalCents = 0;
      let selectedCount = 0;
      let allSelectableIncluded = true;

      cards.forEach((card) => {
        const toggle = card.querySelector('[data-builder-item-toggle]');
        const available = card.dataset.available == 'true';
        const isIncluded = Boolean(toggle && toggle.checked && !toggle.disabled && available);

        if (available && !isIncluded) {
          allSelectableIncluded = false;
        }

        card.classList.toggle('is-excluded', !isIncluded);

        if (!isIncluded) return;

        const priceCents = Number.parseInt(card.dataset.priceCents || '0', 10);
        selectedTotalCents += Number.isFinite(priceCents) ? priceCents : 0;
        selectedCount += 1;
      });

      const individualTotal = Number.parseInt(this.currentMatch?.individualTotalCents || 0, 10) || 0;
      const kitPrice = Number.parseInt(this.currentMatch?.kitProduct?.priceCents || 0, 10) || 0;
      const savings = individualTotal - (kitPrice > 0 ? kitPrice : individualTotal);
      const hasSavings = savings > 0;
      const kitAvailable = this.currentMatch?.kitProduct?.available !== false;
      const canShowSavings = hasSavings && kitPrice > 0 && kitAvailable;
      const fullKitSelected = allSelectableIncluded && selectedCount > 0 && kitPrice > 0 && kitAvailable;
      const showSavingsRow = canShowSavings && fullKitSelected;
      const showSavingsMessage = canShowSavings && !fullKitSelected && selectedCount > 0;
      const totalCents = fullKitSelected ? kitPrice : selectedTotalCents;

      if (this.subtotalElement) {
        this.subtotalElement.textContent = this.formatMoney(selectedTotalCents);
      }

      if (this.totalElement) {
        this.totalElement.textContent = this.formatMoney(totalCents);
      }

      if (this.savingsRowElement) {
        this.savingsRowElement.hidden = !showSavingsRow;
      }

      if (this.savingsElement) {
        this.savingsElement.textContent = this.formatMoney(savings);
      }

      if (this.savingsMessageElement) {
        if (showSavingsMessage) {
          this.savingsMessageElement.hidden = false;
          this.savingsMessageElement.textContent = `Buy as a full kit and save ${this.formatMoney(savings)}`;
        } else {
          this.savingsMessageElement.hidden = true;
          this.savingsMessageElement.textContent = '';
        }
      }

      if (this.addSelectedButton) {
        this.addSelectedButton.disabled = selectedCount == 0;
      }
    }

    getSelectedState() {
      const cards = Array.from(this.kitItemsElement.querySelectorAll('[data-builder-kit-card="true"]'));
      const selectedIndividualItems = [];
      let allSelectableIncluded = true;

      cards.forEach((card) => {
        const toggle = card.querySelector('[data-builder-item-toggle]');
        const available = card.dataset.available == 'true';
        const checked = Boolean(toggle && toggle.checked && !toggle.disabled && available);

        if (available && !checked) {
          allSelectableIncluded = false;
        }

        if (!checked) return;

        const variantId = Number.parseInt(card.dataset.variantId || '0', 10);
        if (!Number.isFinite(variantId) || variantId <= 0) return;

        selectedIndividualItems.push({
          id: variantId,
          quantity: 1,
          properties: {
            _suspension_builder_rule: this.currentMatch?.id || '',
            _suspension_builder_mode: 'individual'
          }
        });
      });

      return {
        allSelectableIncluded,
        selectedIndividualItems
      };
    }

    getSelectedCartItems() {
      const state = this.getSelectedState();
      const kitVariantId = Number.parseInt(this.currentMatch?.kitProduct?.variantId || 0, 10);
      const hasKitVariant = Number.isFinite(kitVariantId) && kitVariantId > 0;
      const kitIsAvailable = this.currentMatch?.kitProduct?.available !== false;

      if (state.allSelectableIncluded && hasKitVariant && kitIsAvailable) {
        return [
          {
            id: kitVariantId,
            quantity: 1,
            properties: {
              _suspension_builder_rule: this.currentMatch?.id || '',
              _suspension_builder_mode: 'kit'
            }
          }
        ];
      }

      return state.selectedIndividualItems;
    }

    async handleAddSelected() {
      if (!this.currentMatch) return;

      const selectedItems = this.getSelectedCartItems();
      if (!selectedItems.length) {
        this.setFeedback('Select at least one item before adding to cart.', 'error');
        return;
      }

      this.setBusyState(true);
      this.setFeedback('Adding selected items to cart...', 'info');

      try {
        const response = await fetch(`${this.routeRoot}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: selectedItems })
        });

        if (!response.ok) {
          let message = 'Unable to add items to cart. Please try again.';
          try {
            const errorData = await response.json();
            if (errorData?.description) {
              message = errorData.description;
            }
          } catch (error) {
            // Keep fallback message.
          }
          throw new Error(message);
        }

        if (window?.Shopify?.designMode) {
          this.setFeedback('Added to cart. Open the storefront preview to view your cart.', 'success');
          return;
        }

        this.setFeedback('Added to cart.', 'success');
        window.dispatchEvent(
          new CustomEvent('cart:open', {
            detail: {
              source: 'home-builder-strip'
            }
          })
        );
        window.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: {
              source: 'home-builder-strip'
            }
          })
        );
      } catch (error) {
        this.setFeedback(error.message || 'Unable to add items to cart. Please try again.', 'error');
      } finally {
        this.setBusyState(false);
      }
    }

    setBusyState(isBusy) {
      if (this.addSelectedButton) {
        this.addSelectedButton.disabled = isBusy;
      }
      if (this.submitButton) {
        this.submitButton.disabled = isBusy;
      }
      this.section.classList.toggle('is-busy', isBusy);
    }
  }

  class HomeBuilderScrollBlur {
    constructor(sectionElement) {
      this.section = sectionElement;
      this.strip = this.section?.querySelector('.home-builder__strip');
      this.linkedIntro = this.findLinkedIntroSection();
      this.prefersReducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.rafId = null;
      this.isTicking = false;

      if (!this.section || !this.strip) return;

      if (this.linkedIntro) {
        this.linkedIntro.setAttribute('data-builder-linked-intro', 'true');
      }

      const computedStyles = window.getComputedStyle(this.section);
      const maxBlurFromStyle = Number.parseFloat(computedStyles.getPropertyValue('--builder-scroll-blur-max'));
      this.maxBlurPx = Number.isFinite(maxBlurFromStyle) ? maxBlurFromStyle : 12;

      this.onViewportChange = this.requestUpdate.bind(this);
      this.onMotionPreferenceChange = this.handleMotionPreferenceChange.bind(this);

      window.addEventListener('scroll', this.onViewportChange, { passive: true });
      window.addEventListener('resize', this.onViewportChange);

      if (typeof this.prefersReducedMotionQuery?.addEventListener == 'function') {
        this.prefersReducedMotionQuery.addEventListener('change', this.onMotionPreferenceChange);
      } else if (typeof this.prefersReducedMotionQuery?.addListener == 'function') {
        this.prefersReducedMotionQuery.addListener(this.onMotionPreferenceChange);
      }

      this.update();
    }

    findLinkedIntroSection() {
      const sectionWrapper = this.section?.closest('.shopify-section');
      if (!sectionWrapper) return null;

      let previousWrapper = sectionWrapper.previousElementSibling;
      while (previousWrapper) {
        const introElement = previousWrapper.querySelector('.home-intro');
        if (introElement) return introElement;
        previousWrapper = previousWrapper.previousElementSibling;
      }

      return null;
    }

    handleMotionPreferenceChange() {
      this.requestUpdate();
    }

    requestUpdate() {
      if (!this.section || !this.strip || this.isTicking) return;

      this.isTicking = true;
      this.rafId = window.requestAnimationFrame(() => {
        this.isTicking = false;
        this.update();
      });
    }

    update() {
      if (!this.section || !this.strip) return;

      if (this.prefersReducedMotionQuery?.matches) {
        this.section.style.setProperty('--builder-scroll-blur', '0px');
        if (this.linkedIntro) {
          this.linkedIntro.style.setProperty('--builder-linked-intro-blur', '0px');
        }
        return;
      }

      const rect = this.section.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
      const stripStartUnblurAt = viewportHeight * 1.32;
      const stripEndUnblurAt = viewportHeight * 0.74;
      const stripRange = Math.max(1, stripStartUnblurAt - stripEndUnblurAt);
      const revealProgress = (stripStartUnblurAt - rect.top) / stripRange;
      const clampedProgress = Math.min(1, Math.max(0, revealProgress));
      const blurAmount = Math.max(0, this.maxBlurPx * (1 - clampedProgress));
      const introStartUnblurAt = viewportHeight * 1.5;
      const introEndUnblurAt = viewportHeight * 0.98;
      const introRange = Math.max(1, introStartUnblurAt - introEndUnblurAt);
      const introRevealProgress = (introStartUnblurAt - rect.top) / introRange;
      const introClampedProgress = Math.min(1, Math.max(0, introRevealProgress));
      const introBlurAmount = Math.max(0, this.maxBlurPx * (1 - introClampedProgress));

      this.section.style.setProperty('--builder-scroll-blur', `${blurAmount.toFixed(2)}px`);
      if (this.linkedIntro) {
        this.linkedIntro.style.setProperty('--builder-linked-intro-blur', `${introBlurAmount.toFixed(2)}px`);
      }
    }

    destroy() {
      if (this.rafId) {
        window.cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      window.removeEventListener('scroll', this.onViewportChange);
      window.removeEventListener('resize', this.onViewportChange);

      if (typeof this.prefersReducedMotionQuery?.removeEventListener == 'function') {
        this.prefersReducedMotionQuery.removeEventListener('change', this.onMotionPreferenceChange);
      } else if (typeof this.prefersReducedMotionQuery?.removeListener == 'function') {
        this.prefersReducedMotionQuery.removeListener(this.onMotionPreferenceChange);
      }

      if (this.section) {
        this.section.style.setProperty('--builder-scroll-blur', '0px');
      }

      if (this.linkedIntro) {
        this.linkedIntro.style.setProperty('--builder-linked-intro-blur', '0px');
        this.linkedIntro.removeAttribute('data-builder-linked-intro');
      }
    }
  }

  const initHomeBuilderForms = (rootElement = document) => {
    rootElement.querySelectorAll('[data-home-builder-form]').forEach((formElement) => {
      if (!formElement.__homeBuilderInitialized) {
        formElement.__homeBuilderInitialized = true;
        try {
          new HomeBuilderForm(formElement);
          const sectionElement = formElement.closest('[data-home-builder]');
          if (sectionElement && !sectionElement.__homeBuilderBlurReveal) {
            sectionElement.__homeBuilderBlurReveal = new HomeBuilderScrollBlur(sectionElement);
          }
        } catch (error) {
          formElement.__homeBuilderInitialized = false;
          // Keep the editor and storefront alive if one section instance throws.
          console.error('[HomeBuilderForm] initialization failed', error);
        }
      }
    });
  };

  initHomeBuilderForms(document);

  document.addEventListener('shopify:section:load', (event) => {
    initHomeBuilderForms(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionElement = event.target.matches('[data-home-builder]')
      ? event.target
      : event.target.querySelector('[data-home-builder]');

    if (!sectionElement) return;

    const blurReveal = sectionElement.__homeBuilderBlurReveal;
    if (blurReveal && typeof blurReveal.destroy == 'function') {
      blurReveal.destroy();
    }
    sectionElement.__homeBuilderBlurReveal = null;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-category-grid"] && !Shopify.designMode) return;
  try {
    
  class HomeCategoryGridCarousel {
    constructor(sectionElement) {
      this.section = sectionElement;
      this.viewport = this.section.querySelector('[data-grid-viewport]');
      this.track = this.section.querySelector('[data-grid-track]');
      this.controls = this.section.querySelector('[data-grid-controls]');
      this.paginationWrap = this.section.querySelector('[data-grid-pagination-wrap]');
      this.prevButton = this.section.querySelector('[data-grid-prev]');
      this.nextButton = this.section.querySelector('[data-grid-next]');
      this.pagination = this.section.querySelector('[data-grid-pagination]');
      this.mobileEnabled = this.section.dataset.mobileCarouselEnabled === 'true';

      this.isActive = false;
      this.currentIndex = 0;
      this.originalSlides = [];
      this.scrollSettleTimer = null;
      this.isAdjusting = false;
      this.scrollAnimationFrame = null;
      this.scrollAnimationRestoreTimer = null;
      this.revealObserver = null;
      this.revealSequenceIndex = 0;
      this.prefersReducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!this.track) return;

      this.onResize = this.handleResize.bind(this);
      this.onTrackScroll = this.handleTrackScroll.bind(this);
      this.onPrevClick = this.handlePrevClick.bind(this);
      this.onNextClick = this.handleNextClick.bind(this);
      this.onPaginationClick = this.handlePaginationClick.bind(this);
      this.onMotionPreferenceChange = this.handleMotionPreferenceChange.bind(this);

      window.addEventListener('resize', this.onResize);
      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);
      if (this.pagination) this.pagination.addEventListener('click', this.onPaginationClick);
      this.bindMotionPreferenceListener();
      this.setupRevealAnimation();

      this.handleResize();
    }

    isMobileViewport() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    handleResize() {
      if (this.mobileEnabled && this.isMobileViewport()) {
        this.enableMobileCarousel();
        if (this.isActive) {
          this.scrollToDomIndex(this.currentIndex, 'auto');
          this.updatePagination();
        }
      } else {
        this.disableMobileCarousel();
      }
    }

    handleMotionPreferenceChange() {
      this.setupRevealAnimation();
    }

    bindMotionPreferenceListener() {
      if (!this.prefersReducedMotionQuery) return;

      if (typeof this.prefersReducedMotionQuery.addEventListener == 'function') {
        this.prefersReducedMotionQuery.addEventListener('change', this.onMotionPreferenceChange);
      } else if (typeof this.prefersReducedMotionQuery.addListener == 'function') {
        this.prefersReducedMotionQuery.addListener(this.onMotionPreferenceChange);
      }
    }

    unbindMotionPreferenceListener() {
      if (!this.prefersReducedMotionQuery) return;

      if (typeof this.prefersReducedMotionQuery.removeEventListener == 'function') {
        this.prefersReducedMotionQuery.removeEventListener('change', this.onMotionPreferenceChange);
      } else if (typeof this.prefersReducedMotionQuery.removeListener == 'function') {
        this.prefersReducedMotionQuery.removeListener(this.onMotionPreferenceChange);
      }
    }

    getRevealSlides() {
      return Array.from(this.track.querySelectorAll('[data-grid-slide]')).filter((slide) => slide.dataset.clone != 'true');
    }

    setupRevealAnimation() {
      if (!this.track) return;

      const revealSlides = this.getRevealSlides();
      if (!revealSlides.length) return;

      if (this.revealObserver) {
        this.revealObserver.disconnect();
        this.revealObserver = null;
      }

      if (this.prefersReducedMotionQuery?.matches || typeof window.IntersectionObserver == 'undefined') {
        revealSlides.forEach((slide) => {
          slide.classList.add('is-visible');
          slide.style.removeProperty('--grid-reveal-delay');
        });
        return;
      }

      this.revealSequenceIndex = revealSlides.filter((slide) => slide.classList.contains('is-visible')).length;

      this.revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const slide = entry.target;
            if (slide.classList.contains('is-visible')) {
              this.revealObserver?.unobserve(slide);
              return;
            }

            const delayMs = Math.min(this.revealSequenceIndex * 110, 660);
            this.revealSequenceIndex += 1;
            slide.style.setProperty('--grid-reveal-delay', `${delayMs}ms`);
            slide.classList.add('is-visible');
            this.revealObserver?.unobserve(slide);
          });
        },
        {
          threshold: 0.2,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      revealSlides.forEach((slide) => {
        if (slide.classList.contains('is-visible')) return;
        this.revealObserver.observe(slide);
      });
    }

    enableMobileCarousel() {
      if (this.isActive) return;

      this.track.querySelectorAll('[data-clone="true"]').forEach((clone) => clone.remove());
      this.originalSlides = Array.from(this.track.querySelectorAll('[data-grid-slide]'));
      if (this.originalSlides.length <= 1) {
        this.section.classList.remove('home-category-grid--mobile-carousel');
        if (this.controls) this.controls.hidden = true;
        if (this.paginationWrap) this.paginationWrap.hidden = true;
        return;
      }

      this.section.classList.add('home-category-grid--mobile-carousel');
      this.track.addEventListener('scroll', this.onTrackScroll, { passive: true });
      this.isActive = true;

      this.buildPagination();

      requestAnimationFrame(() => {
        this.scrollToDomIndex(0, 'auto');
        this.currentIndex = 0;
        this.updatePagination();
        if (this.controls) this.controls.hidden = false;
        if (this.paginationWrap) this.paginationWrap.hidden = false;

        window.setTimeout(() => {
          if (!this.isActive) return;
          this.scrollToDomIndex(this.currentIndex, 'auto');
          this.updatePagination();
        }, 90);
      });
    }

    disableMobileCarousel() {
      if (!this.isActive) {
        if (this.controls) this.controls.hidden = true;
        if (this.paginationWrap) this.paginationWrap.hidden = true;
        return;
      }

      this.track.removeEventListener('scroll', this.onTrackScroll);
      if (this.scrollSettleTimer) {
        window.clearTimeout(this.scrollSettleTimer);
        this.scrollSettleTimer = null;
      }
      if (this.scrollAnimationFrame) {
        window.cancelAnimationFrame(this.scrollAnimationFrame);
        this.scrollAnimationFrame = null;
      }
      if (this.scrollAnimationRestoreTimer) {
        window.clearTimeout(this.scrollAnimationRestoreTimer);
        this.scrollAnimationRestoreTimer = null;
      }
      this.track.classList.remove('is-animating');

      this.track.querySelectorAll('[data-clone="true"]').forEach((clone) => clone.remove());
      this.section.classList.remove('home-category-grid--mobile-carousel');
      this.clearPagination();
      if (this.controls) this.controls.hidden = true;
      if (this.paginationWrap) this.paginationWrap.hidden = true;

      this.isActive = false;
      this.currentIndex = 0;
      this.originalSlides = [];
      this.isAdjusting = false;
      this.updateNavState();
    }

    handleTrackScroll() {
      if (this.isAdjusting || !this.isActive) return;

      if (this.scrollSettleTimer) {
        window.clearTimeout(this.scrollSettleTimer);
      }

      this.scrollSettleTimer = window.setTimeout(() => {
        this.handleScrollSettled();
      }, 100);
    }

    handleScrollSettled() {
      if (!this.isActive) return;

      const nearestDomIndex = this.getNearestDomIndex();
      this.currentIndex = Math.min(Math.max(0, nearestDomIndex), this.originalSlides.length - 1);
      this.updatePagination();
    }

    getNearestDomIndex() {
      const slides = Array.from(this.track.children);
      if (!slides.length) return 0;

      const scrollLeft = this.track.scrollLeft;
      const inset = this.getTrackInset();

      let bestIndex = 0;
      let bestDistance = Number.POSITIVE_INFINITY;

      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - inset - scrollLeft);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      return bestIndex;
    }

    scrollToDomIndex(domIndex, behavior = 'smooth') {
      const slides = this.track.children;
      if (!slides.length) return;

      const safeIndex = Math.min(Math.max(0, domIndex), slides.length - 1);
      const targetSlide = slides[safeIndex];
      if (!targetSlide) return;

      const targetLeft = Math.max(0, targetSlide.offsetLeft - this.getTrackInset());

      if (behavior == 'auto') {
        this.track.scrollLeft = targetLeft;
        return;
      }

      if (behavior == 'smooth') {
        this.track.scrollTo({ left: targetLeft, behavior: 'smooth' });
        return;
      }

      this.track.scrollTo({ left: targetLeft, behavior });
    }

    animateTrackTo(targetLeft) {
      if (this.scrollAnimationFrame) {
        window.cancelAnimationFrame(this.scrollAnimationFrame);
        this.scrollAnimationFrame = null;
      }
      if (this.scrollAnimationRestoreTimer) {
        window.clearTimeout(this.scrollAnimationRestoreTimer);
        this.scrollAnimationRestoreTimer = null;
      }

      const startLeft = this.track.scrollLeft;
      const distance = targetLeft - startLeft;
      if (Math.abs(distance) < 1) {
        this.track.scrollLeft = targetLeft;
        return;
      }

      const duration = 500;
      const startTime = performance.now();
      const easeOutCubic = (value) => 1 - Math.pow(1 - value, 3);
      this.track.classList.add('is-animating');

      const step = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(1, elapsed / duration);
        const eased = easeOutCubic(progress);
        this.track.scrollLeft = startLeft + distance * eased;

        if (progress < 1) {
          this.scrollAnimationFrame = window.requestAnimationFrame(step);
          return;
        }

        this.scrollAnimationFrame = null;
        this.scrollAnimationRestoreTimer = window.setTimeout(() => {
          this.track.classList.remove('is-animating');
          this.scrollAnimationRestoreTimer = null;
        }, 90);
      };

      this.scrollAnimationFrame = window.requestAnimationFrame(step);
    }

    getTrackInset() {
      if (!this.isActive) return 0;
      const computed = window.getComputedStyle(this.track);
      const paddingLeft = Number.parseFloat(computed.paddingLeft || '0');
      return Number.isFinite(paddingLeft) ? paddingLeft : 0;
    }

    goToRealIndex(realIndex, behavior = 'smooth') {
      this.currentIndex = Math.min(Math.max(0, realIndex), this.originalSlides.length - 1);
      this.scrollToDomIndex(this.currentIndex, behavior);
      this.updatePagination();
    }

    handlePrevClick() {
      if (!this.isActive) return;
      this.goToRealIndex(this.currentIndex - 1, 'smooth');
    }

    handleNextClick() {
      if (!this.isActive) return;
      this.goToRealIndex(this.currentIndex + 1, 'smooth');
    }

    buildPagination() {
      if (!this.pagination) return;
      this.pagination.innerHTML = '';

      this.originalSlides.forEach((_, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'home-category-grid__dot';
        button.dataset.index = String(index);
        button.setAttribute('aria-label', `Go to slide ${index + 1}`);
        this.pagination.appendChild(button);
      });

      this.updatePagination();
    }

    clearPagination() {
      if (!this.pagination) return;
      this.pagination.innerHTML = '';
    }

    handlePaginationClick(event) {
      const button = event.target.closest('.home-category-grid__dot');
      if (!button || !this.isActive) return;

      const index = Number.parseInt(button.dataset.index || '0', 10);
      if (!Number.isFinite(index)) return;
      this.goToRealIndex(index, 'smooth');
    }

    updatePagination() {
      if (!this.pagination) return;
      const dots = this.pagination.querySelectorAll('.home-category-grid__dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === this.currentIndex);
      });
      this.updateNavState();
    }

    updateNavState() {
      const maxIndex = this.originalSlides.length - 1;
      if (this.prevButton) {
        const disabled = !this.isActive || this.currentIndex <= 0;
        this.prevButton.disabled = disabled;
      }
      if (this.nextButton) {
        const disabled = !this.isActive || this.currentIndex >= maxIndex;
        this.nextButton.disabled = disabled;
      }
    }

    destroy() {
      this.disableMobileCarousel();
      window.removeEventListener('resize', this.onResize);
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
      if (this.pagination) this.pagination.removeEventListener('click', this.onPaginationClick);
      this.unbindMotionPreferenceListener();
      if (this.revealObserver) {
        this.revealObserver.disconnect();
        this.revealObserver = null;
      }
    }
  }

  const homeCategoryGridInstances = new WeakMap();

  const initHomeCategoryGrids = (rootElement = document) => {
    if (rootElement.matches && rootElement.matches('[data-home-category-grid]')) {
      if (!homeCategoryGridInstances.has(rootElement)) {
        const instance = new HomeCategoryGridCarousel(rootElement);
        homeCategoryGridInstances.set(rootElement, instance);
      }
      return;
    }

    rootElement.querySelectorAll('[data-home-category-grid]').forEach((gridElement) => {
      if (homeCategoryGridInstances.has(gridElement)) return;
      const instance = new HomeCategoryGridCarousel(gridElement);
      homeCategoryGridInstances.set(gridElement, instance);
    });
  };

  initHomeCategoryGrids(document);

  document.addEventListener('shopify:section:load', (event) => {
    initHomeCategoryGrids(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const gridElement = event.target.matches('[data-home-category-grid]')
      ? event.target
      : event.target.querySelector('[data-home-category-grid]');
    if (!gridElement) return;

    const instance = homeCategoryGridInstances.get(gridElement);
    if (!instance) return;

    instance.destroy();
    homeCategoryGridInstances.delete(gridElement);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-essential-upgrades"] && !Shopify.designMode) return;
  try {
    
  class HomeFeaturedProductsCarousel {
    constructor(section) {
      this.section = section;
      this.viewport = section.querySelector('[data-hfp-viewport]');
      this.trackWrap = section.querySelector('[data-hfp-track-wrap]');
      this.track = section.querySelector('[data-hfp-track]');
      this.heading = section.querySelector('[data-hfp-reveal="heading"]');
      this.reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoSpeed = Number.parseFloat(section.dataset.hfpAutoscrollSpeed || '');
      this.autoSpeed = Number.isFinite(this.autoSpeed) && this.autoSpeed > 0 ? this.autoSpeed : 18;
      this.loopWidth = 0;
      this.originalCards = [];
      this.autoPosition = 0;
      this.isVisible = false;
      this.isDragging = false;
      this.pauseUntil = 0;
      this.suppressClickUntil = 0;
      this.lastTimestamp = 0;
      this.rafId = null;
      this.pointerId = null;
      this.activePointerType = null;
      this.pointerStartX = 0;
      this.pointerStartY = 0;
      this.pointerStartScrollLeft = 0;
      this.dragThreshold = 8;
      this.dragDistance = 0;

      if (!this.viewport || !this.trackWrap || !this.track) return;

      this.handlePointerDown = this.handlePointerDown.bind(this);
      this.handlePointerMove = this.handlePointerMove.bind(this);
      this.handlePointerUp = this.handlePointerUp.bind(this);
      this.handleClickCapture = this.handleClickCapture.bind(this);
      this.handleNativeDragStart = this.handleNativeDragStart.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.animateAutoScroll = this.animateAutoScroll.bind(this);

      this.setupInfiniteTrack();
      this.bindInteractions();
      this.initReveal();
      window.requestAnimationFrame(() => {
        this.handleResize();
      });
      window.setTimeout(() => {
        this.handleResize();
      }, 450);

      if (this.reduceMotion) {
        this.heading?.classList.add('is-visible');
        this.trackWrap.classList.add('is-visible');
      }
      this.startAutoScrollLoop();
    }

    bindInteractions() {
      this.viewport.addEventListener('pointerdown', this.handlePointerDown);
      this.viewport.addEventListener('pointermove', this.handlePointerMove);
      this.viewport.addEventListener('pointerup', this.handlePointerUp);
      this.viewport.addEventListener('pointercancel', this.handlePointerUp);
      this.viewport.addEventListener('lostpointercapture', this.handlePointerUp);
      this.viewport.addEventListener('click', this.handleClickCapture, true);
      this.viewport.addEventListener('dragstart', this.handleNativeDragStart);
      window.addEventListener('resize', this.handleResize);
    }

    addWindowPointerListeners() {
      window.addEventListener('pointermove', this.handlePointerMove);
      window.addEventListener('pointerup', this.handlePointerUp);
      window.addEventListener('pointercancel', this.handlePointerUp);
    }

    removeWindowPointerListeners() {
      window.removeEventListener('pointermove', this.handlePointerMove);
      window.removeEventListener('pointerup', this.handlePointerUp);
      window.removeEventListener('pointercancel', this.handlePointerUp);
    }

    setupInfiniteTrack() {
      if (!this.track || !this.viewport) return;

      this.originalCards = Array.from(this.track.children);
      if (this.originalCards.length < 2) {
        this.refreshLoopMetrics();
        return;
      }

      this.refreshLoopMetrics();
      this.ensureLoopCapacity();
      this.updateLoopWidthFromDom();
      this.autoPosition = 0;
      this.viewport.scrollLeft = 0;
    }

    refreshLoopMetrics() {
      if (!this.track || !this.originalCards.length) {
        this.loopWidth = 0;
        return;
      }

      const computedStyle = window.getComputedStyle(this.track);
      const gapValue = Number.parseFloat(computedStyle.columnGap || computedStyle.gap || '0');
      const gap = Number.isFinite(gapValue) ? gapValue : 0;

      const cardsWidth = this.originalCards.reduce((sum, card) => {
        const width = card.getBoundingClientRect().width;
        return sum + (Number.isFinite(width) ? width : 0);
      }, 0);

      const setWidth = cardsWidth + gap * Math.max(0, this.originalCards.length);
      if (setWidth > 0) {
        this.loopWidth = setWidth;
      } else {
        const fallbackWidth = this.track.scrollWidth;
        this.loopWidth = Number.isFinite(fallbackWidth) ? fallbackWidth : 0;
      }
    }

    ensureLoopCapacity() {
      if (!this.track || !this.viewport || !this.originalCards.length || this.loopWidth <= 0) return;

      let guard = 0;
      while (this.track.scrollWidth < this.viewport.clientWidth + this.loopWidth * 1.1 && guard < 14) {
        const fragment = document.createDocumentFragment();
        this.originalCards.forEach((card) => {
          const clone = card.cloneNode(true);
          clone.classList.add('is-clone');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button, input, select, textarea').forEach((node) => {
            node.setAttribute('tabindex', '-1');
          });
          fragment.appendChild(clone);
        });
        this.track.appendChild(fragment);
        guard += 1;
      }

      this.updateLoopWidthFromDom();
    }

    updateLoopWidthFromDom() {
      if (!this.track || this.originalCards.length < 2) return;

      const firstOriginal = this.track.children[0];
      const firstClone = this.track.children[this.originalCards.length];
      if (!firstOriginal || !firstClone) return;

      const measuredWidth = firstClone.offsetLeft - firstOriginal.offsetLeft;
      if (Number.isFinite(measuredWidth) && measuredWidth > 0) {
        this.loopWidth = measuredWidth;
      }
    }

    initReveal() {
      if (!('IntersectionObserver' in window) || this.reduceMotion) {
        this.heading?.classList.add('is-visible');
        this.trackWrap.classList.add('is-visible');
        this.isVisible = true;
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.target === this.heading && entry.isIntersecting) {
              this.heading.classList.add('is-visible');
              this.observer.unobserve(this.heading);
            }

            if (entry.target === this.trackWrap) {
              if (entry.isIntersecting) {
                this.trackWrap.classList.add('is-visible');
                this.isVisible = true;
              } else {
                this.isVisible = false;
              }
            }
          });
        },
        {
          threshold: 0.18
        }
      );

      if (this.heading) {
        this.observer.observe(this.heading);
      }
      this.observer.observe(this.trackWrap);
    }

    handleClickCapture(event) {
      if (performance.now() < this.suppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    handleNativeDragStart(event) {
      event.preventDefault();
    }

    setNormalizedScroll(value) {
      if (!this.viewport || !Number.isFinite(value)) return;

      if (this.loopWidth > 0) {
        let normalized = value % this.loopWidth;
        if (normalized < 0) normalized += this.loopWidth;
        this.autoPosition = normalized;
        this.viewport.scrollLeft = normalized;
        return;
      }

      const clamped = Math.max(0, value);
      this.autoPosition = clamped;
      this.viewport.scrollLeft = clamped;
    }

    handlePointerDown(event) {
      if (event.button !== undefined && event.button !== 0) return;
      if (!this.viewport) return;

      this.pointerId = event.pointerId;
      this.activePointerType = event.pointerType || 'mouse';
      this.pointerStartX = event.clientX;
      this.pointerStartY = event.clientY;
      this.pointerStartScrollLeft = Number.isFinite(this.autoPosition) ? this.autoPosition : this.viewport.scrollLeft;
      this.isDragging = false;
      this.dragDistance = 0;
      this.pauseUntil = performance.now() + 200;
      if (this.activePointerType === 'mouse') {
        this.addWindowPointerListeners();
      } else {
        this.viewport.setPointerCapture?.(event.pointerId);
      }
    }

    handlePointerMove(event) {
      if (this.pointerId === null || event.pointerId !== this.pointerId || !this.viewport) return;

      const deltaX = event.clientX - this.pointerStartX;
      const deltaY = event.clientY - this.pointerStartY;
      this.dragDistance = Math.max(this.dragDistance, Math.abs(deltaX));
      const threshold = Number.isFinite(this.dragThreshold) ? this.dragThreshold : 8;
      const shouldDrag = Math.abs(deltaX) > threshold && Math.abs(deltaX) > Math.abs(deltaY);

      if (!shouldDrag && !this.isDragging) return;

      if (!this.isDragging) {
        this.isDragging = true;
        this.viewport.classList.add('is-dragging');
        this.viewport.setPointerCapture?.(event.pointerId);
      }

      event.preventDefault();
      this.setNormalizedScroll(this.pointerStartScrollLeft - deltaX);
    }

    handlePointerUp(event) {
      if (this.pointerId !== null && event.pointerId !== undefined && event.pointerId !== this.pointerId) return;
      if (this.pointerId !== null && this.viewport?.hasPointerCapture?.(this.pointerId)) {
        this.viewport.releasePointerCapture(this.pointerId);
      }
      this.removeWindowPointerListeners();
      this.pointerId = null;
      this.activePointerType = null;
      this.viewport?.classList.remove('is-dragging');
      if (this.isDragging) {
        this.pauseUntil = performance.now() + 1300;
        this.suppressClickUntil = performance.now() + 420;
      }
      this.isDragging = false;
    }

    handleResize() {
      this.refreshLoopMetrics();
      this.ensureLoopCapacity();
      this.updateLoopWidthFromDom();
      const current = Number.isFinite(this.autoPosition) ? this.autoPosition : this.viewport?.scrollLeft || 0;
      this.setNormalizedScroll(current);
    }

    startAutoScrollLoop() {
      if (this.rafId || this.autoSpeed <= 0) return;
      this.lastTimestamp = performance.now();
      this.rafId = window.requestAnimationFrame(this.animateAutoScroll);
    }

    shouldAutoScroll(timestamp) {
      if (!this.viewport) return false;
      if (this.isDragging || this.pointerId !== null) return false;
      if (timestamp < this.pauseUntil) return false;

      if (this.loopWidth > 2) {
        return this.viewport.scrollWidth - this.viewport.clientWidth > 2;
      }

      const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      return maxScroll > 2;
    }

    animateAutoScroll(timestamp) {
      if (!this.viewport) return;
      const deltaMs = Math.min(24, Math.max(0, timestamp - this.lastTimestamp));
      this.lastTimestamp = timestamp;

      if (this.shouldAutoScroll(timestamp)) {
        const distance = (this.autoSpeed * deltaMs) / 1000;
        if (this.loopWidth > 0) {
          this.setNormalizedScroll(this.autoPosition + distance);
        } else {
          const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
          let nextPosition = this.autoPosition + distance;
          if (nextPosition >= maxScroll) {
            nextPosition = 0;
          }
          this.setNormalizedScroll(nextPosition);
        }
      }

      this.rafId = window.requestAnimationFrame(this.animateAutoScroll);
    }

    destroy() {
      this.observer?.disconnect();
      if (this.rafId) {
        window.cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      if (!this.viewport) return;
      this.viewport.removeEventListener('pointerdown', this.handlePointerDown);
      this.viewport.removeEventListener('pointermove', this.handlePointerMove);
      this.viewport.removeEventListener('pointerup', this.handlePointerUp);
      this.viewport.removeEventListener('pointercancel', this.handlePointerUp);
      this.viewport.removeEventListener('lostpointercapture', this.handlePointerUp);
      this.viewport.removeEventListener('click', this.handleClickCapture, true);
      this.viewport.removeEventListener('dragstart', this.handleNativeDragStart);
      this.removeWindowPointerListeners();
      window.removeEventListener('resize', this.handleResize);
    }
  }

  const state =
    window.__homeFeaturedProductsCarouselState ||
    (window.__homeFeaturedProductsCarouselState = {
      instances: new WeakMap(),
      listenersBound: false,
      init: null,
      unload: null
    });

  const init = (root = document) => {
    const sections = root.querySelectorAll?.('[data-hfp-section]') || [];
    sections.forEach((section) => {
      if (state.instances.has(section)) return;
      state.instances.set(section, new HomeFeaturedProductsCarousel(section));
    });
  };

  const unload = (root = document) => {
    const section = root.matches?.('[data-hfp-section]') ? root : root.querySelector?.('[data-hfp-section]');
    if (!section) return;
    const instance = state.instances.get(section);
    if (!instance) return;
    instance.destroy();
    state.instances.delete(section);
  };

  state.init = init;
  state.unload = unload;

  if (!state.listenersBound) {
    document.addEventListener('shopify:section:load', (event) => {
      window.__homeFeaturedProductsCarouselState?.init?.(event.target);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      window.__homeFeaturedProductsCarouselState?.unload?.(event.target);
    });
    document.addEventListener('DOMContentLoaded', () => {
      window.__homeFeaturedProductsCarouselState?.init?.(document);
    });
    window.addEventListener('load', () => {
      window.__homeFeaturedProductsCarouselState?.init?.(document);
      window.setTimeout(() => {
        window.__homeFeaturedProductsCarouselState?.init?.(document);
      }, 500);
    });
    state.listenersBound = true;
  }

  init(document);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-featured-products"] && !Shopify.designMode) return;
  try {
    
  class HomeFeaturedProductsCarousel {
    constructor(section) {
      this.section = section;
      this.viewport = section.querySelector('[data-hfp-viewport]');
      this.trackWrap = section.querySelector('[data-hfp-track-wrap]');
      this.track = section.querySelector('[data-hfp-track]');
      this.heading = section.querySelector('[data-hfp-reveal="heading"]');
      this.reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoSpeed = Number.parseFloat(section.dataset.hfpAutoscrollSpeed || '');
      this.autoSpeed = Number.isFinite(this.autoSpeed) && this.autoSpeed > 0 ? this.autoSpeed : 18;
      this.loopWidth = 0;
      this.originalCards = [];
      this.autoPosition = 0;
      this.isVisible = false;
      this.isDragging = false;
      this.pauseUntil = 0;
      this.suppressClickUntil = 0;
      this.lastTimestamp = 0;
      this.rafId = null;
      this.pointerId = null;
      this.activePointerType = null;
      this.pointerStartX = 0;
      this.pointerStartY = 0;
      this.pointerStartScrollLeft = 0;
      this.dragThreshold = 8;
      this.dragDistance = 0;

      if (!this.viewport || !this.trackWrap || !this.track) return;

      this.handlePointerDown = this.handlePointerDown.bind(this);
      this.handlePointerMove = this.handlePointerMove.bind(this);
      this.handlePointerUp = this.handlePointerUp.bind(this);
      this.handleClickCapture = this.handleClickCapture.bind(this);
      this.handleNativeDragStart = this.handleNativeDragStart.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.animateAutoScroll = this.animateAutoScroll.bind(this);

      this.setupInfiniteTrack();
      this.bindInteractions();
      this.initReveal();
      window.requestAnimationFrame(() => {
        this.handleResize();
      });
      window.setTimeout(() => {
        this.handleResize();
      }, 450);

      if (this.reduceMotion) {
        this.heading?.classList.add('is-visible');
        this.trackWrap.classList.add('is-visible');
      }
      this.startAutoScrollLoop();
    }

    bindInteractions() {
      this.viewport.addEventListener('pointerdown', this.handlePointerDown);
      this.viewport.addEventListener('pointermove', this.handlePointerMove);
      this.viewport.addEventListener('pointerup', this.handlePointerUp);
      this.viewport.addEventListener('pointercancel', this.handlePointerUp);
      this.viewport.addEventListener('lostpointercapture', this.handlePointerUp);
      this.viewport.addEventListener('click', this.handleClickCapture, true);
      this.viewport.addEventListener('dragstart', this.handleNativeDragStart);
      window.addEventListener('resize', this.handleResize);
    }

    addWindowPointerListeners() {
      window.addEventListener('pointermove', this.handlePointerMove);
      window.addEventListener('pointerup', this.handlePointerUp);
      window.addEventListener('pointercancel', this.handlePointerUp);
    }

    removeWindowPointerListeners() {
      window.removeEventListener('pointermove', this.handlePointerMove);
      window.removeEventListener('pointerup', this.handlePointerUp);
      window.removeEventListener('pointercancel', this.handlePointerUp);
    }

    setupInfiniteTrack() {
      if (!this.track || !this.viewport) return;

      this.originalCards = Array.from(this.track.children);
      if (this.originalCards.length < 2) {
        this.refreshLoopMetrics();
        return;
      }

      this.refreshLoopMetrics();
      this.ensureLoopCapacity();
      this.updateLoopWidthFromDom();
      this.autoPosition = 0;
      this.viewport.scrollLeft = 0;
    }

    refreshLoopMetrics() {
      if (!this.track || !this.originalCards.length) {
        this.loopWidth = 0;
        return;
      }

      const computedStyle = window.getComputedStyle(this.track);
      const gapValue = Number.parseFloat(computedStyle.columnGap || computedStyle.gap || '0');
      const gap = Number.isFinite(gapValue) ? gapValue : 0;

      const cardsWidth = this.originalCards.reduce((sum, card) => {
        const width = card.getBoundingClientRect().width;
        return sum + (Number.isFinite(width) ? width : 0);
      }, 0);

      const setWidth = cardsWidth + gap * Math.max(0, this.originalCards.length);
      if (setWidth > 0) {
        this.loopWidth = setWidth;
      } else {
        const fallbackWidth = this.track.scrollWidth;
        this.loopWidth = Number.isFinite(fallbackWidth) ? fallbackWidth : 0;
      }
    }

    ensureLoopCapacity() {
      if (!this.track || !this.viewport || !this.originalCards.length || this.loopWidth <= 0) return;

      let guard = 0;
      while (this.track.scrollWidth < this.viewport.clientWidth + this.loopWidth * 1.1 && guard < 14) {
        const fragment = document.createDocumentFragment();
        this.originalCards.forEach((card) => {
          const clone = card.cloneNode(true);
          clone.classList.add('is-clone');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button, input, select, textarea').forEach((node) => {
            node.setAttribute('tabindex', '-1');
          });
          fragment.appendChild(clone);
        });
        this.track.appendChild(fragment);
        guard += 1;
      }

      this.updateLoopWidthFromDom();
    }

    updateLoopWidthFromDom() {
      if (!this.track || this.originalCards.length < 2) return;

      const firstOriginal = this.track.children[0];
      const firstClone = this.track.children[this.originalCards.length];
      if (!firstOriginal || !firstClone) return;

      const measuredWidth = firstClone.offsetLeft - firstOriginal.offsetLeft;
      if (Number.isFinite(measuredWidth) && measuredWidth > 0) {
        this.loopWidth = measuredWidth;
      }
    }

    initReveal() {
      if (!('IntersectionObserver' in window) || this.reduceMotion) {
        this.heading?.classList.add('is-visible');
        this.trackWrap.classList.add('is-visible');
        this.isVisible = true;
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.target === this.heading && entry.isIntersecting) {
              this.heading.classList.add('is-visible');
              this.observer.unobserve(this.heading);
            }

            if (entry.target === this.trackWrap) {
              if (entry.isIntersecting) {
                this.trackWrap.classList.add('is-visible');
                this.isVisible = true;
              } else {
                this.isVisible = false;
              }
            }
          });
        },
        {
          threshold: 0.18
        }
      );

      if (this.heading) {
        this.observer.observe(this.heading);
      }
      this.observer.observe(this.trackWrap);
    }

    handleClickCapture(event) {
      if (performance.now() < this.suppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    handleNativeDragStart(event) {
      event.preventDefault();
    }

    setNormalizedScroll(value) {
      if (!this.viewport || !Number.isFinite(value)) return;

      if (this.loopWidth > 0) {
        let normalized = value % this.loopWidth;
        if (normalized < 0) normalized += this.loopWidth;
        this.autoPosition = normalized;
        this.viewport.scrollLeft = normalized;
        return;
      }

      const clamped = Math.max(0, value);
      this.autoPosition = clamped;
      this.viewport.scrollLeft = clamped;
    }

    handlePointerDown(event) {
      if (event.button !== undefined && event.button !== 0) return;
      if (!this.viewport) return;

      this.pointerId = event.pointerId;
      this.activePointerType = event.pointerType || 'mouse';
      this.pointerStartX = event.clientX;
      this.pointerStartY = event.clientY;
      this.pointerStartScrollLeft = Number.isFinite(this.autoPosition) ? this.autoPosition : this.viewport.scrollLeft;
      this.isDragging = false;
      this.dragDistance = 0;
      this.pauseUntil = performance.now() + 200;
      if (this.activePointerType === 'mouse') {
        this.addWindowPointerListeners();
      } else {
        this.viewport.setPointerCapture?.(event.pointerId);
      }
    }

    handlePointerMove(event) {
      if (this.pointerId === null || event.pointerId !== this.pointerId || !this.viewport) return;

      const deltaX = event.clientX - this.pointerStartX;
      const deltaY = event.clientY - this.pointerStartY;
      this.dragDistance = Math.max(this.dragDistance, Math.abs(deltaX));
      const threshold = Number.isFinite(this.dragThreshold) ? this.dragThreshold : 8;
      const shouldDrag = Math.abs(deltaX) > threshold && Math.abs(deltaX) > Math.abs(deltaY);

      if (!shouldDrag && !this.isDragging) return;

      if (!this.isDragging) {
        this.isDragging = true;
        this.viewport.classList.add('is-dragging');
        this.viewport.setPointerCapture?.(event.pointerId);
      }

      event.preventDefault();
      this.setNormalizedScroll(this.pointerStartScrollLeft - deltaX);
    }

    handlePointerUp(event) {
      if (this.pointerId !== null && event.pointerId !== undefined && event.pointerId !== this.pointerId) return;
      if (this.pointerId !== null && this.viewport?.hasPointerCapture?.(this.pointerId)) {
        this.viewport.releasePointerCapture(this.pointerId);
      }
      this.removeWindowPointerListeners();
      this.pointerId = null;
      this.activePointerType = null;
      this.viewport?.classList.remove('is-dragging');
      if (this.isDragging) {
        this.pauseUntil = performance.now() + 1300;
        this.suppressClickUntil = performance.now() + 420;
      }
      this.isDragging = false;
    }

    handleResize() {
      this.refreshLoopMetrics();
      this.ensureLoopCapacity();
      this.updateLoopWidthFromDom();
      const current = Number.isFinite(this.autoPosition) ? this.autoPosition : this.viewport?.scrollLeft || 0;
      this.setNormalizedScroll(current);
    }

    startAutoScrollLoop() {
      if (this.rafId || this.autoSpeed <= 0) return;
      this.lastTimestamp = performance.now();
      this.rafId = window.requestAnimationFrame(this.animateAutoScroll);
    }

    shouldAutoScroll(timestamp) {
      if (!this.viewport) return false;
      if (this.isDragging || this.pointerId !== null) return false;
      if (timestamp < this.pauseUntil) return false;

      if (this.loopWidth > 2) {
        return this.viewport.scrollWidth - this.viewport.clientWidth > 2;
      }

      const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      return maxScroll > 2;
    }

    animateAutoScroll(timestamp) {
      if (!this.viewport) return;
      const deltaMs = Math.min(24, Math.max(0, timestamp - this.lastTimestamp));
      this.lastTimestamp = timestamp;

      if (this.shouldAutoScroll(timestamp)) {
        const distance = (this.autoSpeed * deltaMs) / 1000;
        if (this.loopWidth > 0) {
          this.setNormalizedScroll(this.autoPosition + distance);
        } else {
          const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
          let nextPosition = this.autoPosition + distance;
          if (nextPosition >= maxScroll) {
            nextPosition = 0;
          }
          this.setNormalizedScroll(nextPosition);
        }
      }

      this.rafId = window.requestAnimationFrame(this.animateAutoScroll);
    }

    destroy() {
      this.observer?.disconnect();
      if (this.rafId) {
        window.cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      if (!this.viewport) return;
      this.viewport.removeEventListener('pointerdown', this.handlePointerDown);
      this.viewport.removeEventListener('pointermove', this.handlePointerMove);
      this.viewport.removeEventListener('pointerup', this.handlePointerUp);
      this.viewport.removeEventListener('pointercancel', this.handlePointerUp);
      this.viewport.removeEventListener('lostpointercapture', this.handlePointerUp);
      this.viewport.removeEventListener('click', this.handleClickCapture, true);
      this.viewport.removeEventListener('dragstart', this.handleNativeDragStart);
      this.removeWindowPointerListeners();
      window.removeEventListener('resize', this.handleResize);
    }
  }

  const state =
    window.__homeFeaturedProductsCarouselState ||
    (window.__homeFeaturedProductsCarouselState = {
      instances: new WeakMap(),
      listenersBound: false,
      init: null,
      unload: null
    });

  const init = (root = document) => {
    const sections = root.querySelectorAll?.('[data-hfp-section]') || [];
    sections.forEach((section) => {
      if (state.instances.has(section)) return;
      state.instances.set(section, new HomeFeaturedProductsCarousel(section));
    });
  };

  const unload = (root = document) => {
    const section = root.matches?.('[data-hfp-section]') ? root : root.querySelector?.('[data-hfp-section]');
    if (!section) return;
    const instance = state.instances.get(section);
    if (!instance) return;
    instance.destroy();
    state.instances.delete(section);
  };

  state.init = init;
  state.unload = unload;

  if (!state.listenersBound) {
    document.addEventListener('shopify:section:load', (event) => {
      window.__homeFeaturedProductsCarouselState?.init?.(event.target);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      window.__homeFeaturedProductsCarouselState?.unload?.(event.target);
    });
    document.addEventListener('DOMContentLoaded', () => {
      window.__homeFeaturedProductsCarouselState?.init?.(document);
    });
    window.addEventListener('load', () => {
      window.__homeFeaturedProductsCarouselState?.init?.(document);
      window.setTimeout(() => {
        window.__homeFeaturedProductsCarouselState?.init?.(document);
      }, 500);
    });
    state.listenersBound = true;
  }

  init(document);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  class HomeHeroLogoMotion {
    constructor(sectionElement) {
      this.section = sectionElement;
      this.mediaElement = this.section.querySelector('.home-hero__media');
      this.imageElement = this.section.querySelector('.home-hero__image');
      this.startElement = this.section.querySelector('[data-home-hero-logo-start]');
      this.floatingElement = this.section.querySelector('[data-home-hero-logo-floating]');
      this.headerTarget = document.querySelector('[data-header-logo-target]');
      this.headerElement = document.querySelector('[data-site-header]');
      this.logoEasePower = Number.parseFloat(this.section.dataset.logoEasePower || '3');
      this.logoSettleStart = Number.parseFloat(this.section.dataset.logoSettleStart || '72') / 100;
      this.logoSettleDuration = Number.parseFloat(this.section.dataset.logoSettleDuration || '20') / 100;
      this.headerSolidPoint = Number.parseFloat(this.section.dataset.headerSolidPoint || '88') / 100;
      this.logoHandoffPoint = Number.parseFloat(this.section.dataset.logoHandoffPoint || '90') / 100;
      this.parallaxStrength = Number.parseFloat(this.section.dataset.parallaxStrength || '26');
      this.mobileLogoOffsetX = Number.parseFloat(this.section.dataset.mobileLogoOffsetX || '0');
      this.mobileLogoOffsetY = Number.parseFloat(this.section.dataset.mobileLogoOffsetY || '0');
      this.mobileLogoScale = Number.parseFloat(this.section.dataset.mobileLogoScale || '100') / 100;
      this.lockedScrollY = null;
      this.ticking = false;

      if (!Number.isFinite(this.logoEasePower)) this.logoEasePower = 3;
      if (!Number.isFinite(this.logoSettleStart)) this.logoSettleStart = 0.72;
      if (!Number.isFinite(this.logoSettleDuration)) this.logoSettleDuration = 0.2;
      if (!Number.isFinite(this.headerSolidPoint)) this.headerSolidPoint = 0.88;
      if (!Number.isFinite(this.logoHandoffPoint)) this.logoHandoffPoint = 0.9;
      if (!Number.isFinite(this.parallaxStrength)) this.parallaxStrength = 26;
      if (!Number.isFinite(this.mobileLogoOffsetX)) this.mobileLogoOffsetX = 0;
      if (!Number.isFinite(this.mobileLogoOffsetY)) this.mobileLogoOffsetY = 0;
      if (!Number.isFinite(this.mobileLogoScale) || this.mobileLogoScale <= 0) this.mobileLogoScale = 1;
      this.canAnimateLogo = Boolean(this.startElement && this.floatingElement && this.headerTarget && this.headerElement);

      if (this.canAnimateLogo) {
        this.applyHeaderLogoOffset();
      }
      document.documentElement.classList.remove('home-hero-pending');

      this.onScroll = this.handleScroll.bind(this);
      this.onResize = this.handleResize.bind(this);
      this.onWindowLoad = this.handleWindowLoad.bind(this);
      this.onImageLoad = this.handleImageLoad.bind(this);
      this.onSearchOverlayToggle = this.handleSearchOverlayToggle.bind(this);

      if (this.canAnimateLogo) {
        document.body.classList.add('home-hero-logo-active');
      }
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      window.addEventListener('site:search-overlay-toggle', this.onSearchOverlayToggle);
      if (this.imageElement && !this.imageElement.complete) {
        this.imageElement.addEventListener('load', this.onImageLoad, { once: true });
      }
      this.updateStartLogoAnchor();
      this.update();
      this.primeAnimation();

      if (document.readyState !== 'complete') {
        window.addEventListener('load', this.onWindowLoad, { once: true });
      }

    }

    handleScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    handleResize() {
      this.updateStartLogoAnchor();
      if (this.canAnimateLogo) {
        this.applyHeaderLogoOffset();
      }
      this.update();
    }

    handleWindowLoad() {
      this.updateStartLogoAnchor();
      this.primeAnimation();
    }

    handleImageLoad() {
      this.updateStartLogoAnchor();
      this.primeAnimation();
    }

    handleSearchOverlayToggle(event) {
      const detail = event?.detail || {};
      this.lockedScrollY = detail.open ? Number(detail.scrollY || 0) : null;
      this.update();
    }

    primeAnimation() {
      requestAnimationFrame(() => {
        this.updateStartLogoAnchor();
        this.update();
        requestAnimationFrame(() => {
          this.updateStartLogoAnchor();
          this.update();
        });
      });
    }

    getCurrentLogoAnchor() {
      const styles = getComputedStyle(this.section);
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const isTablet = !isMobile && window.matchMedia('(max-width: 989px)').matches;

      const left = isMobile
        ? parseFloat(styles.getPropertyValue('--hero-logo-left-mobile')) || 50
        : isTablet
          ? parseFloat(styles.getPropertyValue('--hero-logo-left-tablet')) || parseFloat(styles.getPropertyValue('--hero-logo-left')) || 50
          : parseFloat(styles.getPropertyValue('--hero-logo-left')) || 50;

      const top = isMobile
        ? parseFloat(styles.getPropertyValue('--hero-logo-top-mobile')) || 24
        : isTablet
          ? parseFloat(styles.getPropertyValue('--hero-logo-top-tablet')) || parseFloat(styles.getPropertyValue('--hero-logo-top')) || 24
          : parseFloat(styles.getPropertyValue('--hero-logo-top')) || 24;

      return { left, top, isMobile };
    }

    getCurrentImageObjectPosition() {
      if (window.matchMedia('(max-width: 749px)').matches) {
        return { x: 50, y: 86 };
      }

      if (window.matchMedia('(min-width: 1024px)').matches) {
        return { x: 50, y: 100 };
      }

      return { x: 50, y: 82 };
    }

    updateStartLogoAnchor() {
      if (!this.startElement || !this.mediaElement || !this.imageElement) return;
      if (!this.imageElement.naturalWidth || !this.imageElement.naturalHeight) return;

      const mediaWidth = this.mediaElement.clientWidth;
      const mediaHeight = this.mediaElement.clientHeight;
      if (!mediaWidth || !mediaHeight) return;

      const { left, top } = this.getCurrentLogoAnchor();
      const objectPosition = this.getCurrentImageObjectPosition();
      const imageWidth = this.imageElement.naturalWidth;
      const imageHeight = this.imageElement.naturalHeight;
      const coverScale = Math.max(mediaWidth / imageWidth, mediaHeight / imageHeight);
      const renderedWidth = imageWidth * coverScale;
      const renderedHeight = imageHeight * coverScale;
      const offsetX = (mediaWidth - renderedWidth) * (objectPosition.x / 100);
      const offsetY = (mediaHeight - renderedHeight) * (objectPosition.y / 100);
      const anchoredX = offsetX + renderedWidth * (left / 100);
      const anchoredY = offsetY + renderedHeight * (top / 100);

      this.startElement.style.left = `${anchoredX.toFixed(2)}px`;
      this.startElement.style.top = `${anchoredY.toFixed(2)}px`;
    }

    applyHeaderLogoOffset() {
      document.documentElement.style.setProperty('--home-mobile-logo-offset-x', `${this.mobileLogoOffsetX}px`);
    }

    getEffectiveScrollY() {
      if (Number.isFinite(this.lockedScrollY)) {
        return this.lockedScrollY;
      }

      if (document.body.classList.contains('site-search-overlay-open')) {
        const lockedBodyTop = Number.parseFloat(document.body.style.top || '0');
        if (Number.isFinite(lockedBodyTop) && lockedBodyTop !== 0) {
          return Math.abs(lockedBodyTop);
        }
      }

      return window.scrollY || window.pageYOffset || 0;
    }

    getProgress() {
      const sectionTop = this.section.offsetTop;
      const headerHeight = this.headerElement ? this.headerElement.offsetHeight || 0 : 0;
      const animationEnd = sectionTop + this.section.offsetHeight - headerHeight;
      const range = Math.max(1, animationEnd - sectionTop);
      const raw = (this.getEffectiveScrollY() - sectionTop) / range;
      return Math.min(1, Math.max(0, raw));
    }

    update() {
      const progress = this.getProgress();
      const clampedParallaxStrength = Math.min(120, Math.max(-120, this.parallaxStrength));
      const isMobileViewport = window.matchMedia('(max-width: 749px)').matches;
      const parallaxMultiplier = isMobileViewport ? 1.85 : 3;
      const parallaxY = -progress * (clampedParallaxStrength * parallaxMultiplier);
      this.section.style.setProperty('--home-hero-image-offset-y', `${parallaxY.toFixed(2)}px`);
      const easePower = Math.min(6, Math.max(1, this.logoEasePower));
      const contentFadeEnd = 0.28;
      const contentFadeProgress = Math.min(1, Math.max(0, progress / contentFadeEnd));
      const contentOpacity = 1 - Math.pow(contentFadeProgress, 1.2);
      const eased = 1 - Math.pow(1 - progress, easePower);
      const solidPoint = Math.min(0.98, Math.max(0.65, this.headerSolidPoint));
      const handoffPoint = Math.min(1, Math.max(solidPoint, this.logoHandoffPoint));
      const isHeaderSolid = progress >= solidPoint;
      const isHeaderLogoVisible = progress >= handoffPoint;

      this.section.style.setProperty('--home-hero-content-opacity', contentOpacity.toFixed(3));

      if (!this.canAnimateLogo) {
        return;
      }

      // Apply state first so target measurements match the current UI state.
      document.body.classList.toggle('home-header-solid', isHeaderSolid);
      document.body.classList.toggle('home-header-logo-visible', isHeaderLogoVisible);

      const startRect = this.startElement.getBoundingClientRect();
      const targetVisual =
        this.headerTarget.querySelector('.site-header__logo-image--dark, .site-header__logo-stack, .site-header__logo-text') ||
        this.headerTarget;
      const targetVisualRect = targetVisual.getBoundingClientRect();

      if (startRect.width <= 0 || targetVisualRect.width <= 0) {
        return;
      }

      const isMobile = window.matchMedia('(max-width: 989px)').matches;
      const targetScaleAdjust = isMobile ? this.mobileLogoScale : 1;
      const targetOffsetY = isMobile ? this.mobileLogoOffsetY : 0;
      const targetWidth = targetVisualRect.width * targetScaleAdjust;
      const targetHeight =
        targetVisualRect.height > 0
          ? targetVisualRect.height * targetScaleAdjust
          : startRect.height * (targetWidth / startRect.width);
      const targetCenterX = targetVisualRect.left + targetVisualRect.width / 2;
      const targetCenterY = targetVisualRect.top + targetVisualRect.height / 2 + targetOffsetY;
      const targetX = targetCenterX - targetWidth / 2;
      const targetY = targetCenterY - targetHeight / 2;

      // Lock scale to width so the floating logo matches header logo width exactly.
      const targetScale = targetWidth / startRect.width;
      let scale = 1 + (targetScale - 1) * eased;
      const startX = startRect.left;
      const startY = startRect.top;
      let x = startX + (targetX - startX) * eased;
      let y = startY + (targetY - startY) * eased;

      // Settle into the exact target near the end so mobile alignment stays centered.
      const settleStart = Math.min(0.95, Math.max(0.4, this.logoSettleStart));
      const settleDuration = Math.min(0.5, Math.max(0.06, this.logoSettleDuration));
      const settle = Math.min(1, Math.max(0, (progress - settleStart) / settleDuration));
      scale = scale + (targetScale - scale) * settle;
      x = x + (targetX - x) * settle;
      y = y + (targetY - y) * settle;

      // Never allow the floating logo to travel above the final header target.
      y = Math.max(y, targetY);

      // When the header logo becomes visible, snap to the exact same geometry.
      if (isHeaderLogoVisible) {
        scale = targetScale;
        x = targetX;
        y = targetY;
      }

      this.floatingElement.style.width = `${startRect.width}px`;
      this.floatingElement.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;

      // Final correction pass: match rendered floating bounds to the header target exactly.
      if (isHeaderLogoVisible) {
        const floatingRect = this.floatingElement.getBoundingClientRect();
        const dx = targetX - floatingRect.left;
        const dy = targetY - floatingRect.top;
        if (Math.abs(dx) > 0.1 || Math.abs(dy) > 0.1) {
          x += dx;
          y += dy;
          this.floatingElement.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
        }
      }

      this.floatingElement.style.opacity = progress >= handoffPoint ? '0' : '1';
    }

    destroy() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('load', this.onWindowLoad);
      window.removeEventListener('site:search-overlay-toggle', this.onSearchOverlayToggle);
      if (this.imageElement) {
        this.imageElement.removeEventListener('load', this.onImageLoad);
      }
      document.documentElement.classList.remove('home-hero-pending');
      document.documentElement.style.removeProperty('--home-mobile-logo-offset-x');
      this.section.style.removeProperty('--home-hero-image-offset-y');
      this.section.style.removeProperty('--home-hero-content-opacity');
      document.body.classList.remove('home-header-solid');
      document.body.classList.remove('home-header-logo-visible');
      document.body.classList.remove('home-hero-logo-active');
      if (this.startElement) {
        this.startElement.style.removeProperty('left');
        this.startElement.style.removeProperty('top');
      }
    }
  }

  const homeHeroInstances = new WeakMap();
  const isElementNode = (node) => Boolean(node && node.nodeType == 1);

  const initHomeHeroMotion = (rootElement = document) => {
    if (!rootElement) return;

    if (rootElement.matches && rootElement.matches('[data-home-hero]')) {
      if (!homeHeroInstances.has(rootElement)) {
        try {
          const instance = new HomeHeroLogoMotion(rootElement);
          if (instance) {
            homeHeroInstances.set(rootElement, instance);
          }
        } catch (error) {
          console.error('[HomeHeroLogoMotion] initialization failed', error);
        }
      }
      return;
    }

    if (typeof rootElement.querySelectorAll != 'function') return;
    rootElement.querySelectorAll('[data-home-hero]').forEach((heroElement) => {
      if (homeHeroInstances.has(heroElement)) return;
      try {
        const instance = new HomeHeroLogoMotion(heroElement);
        if (instance) {
          homeHeroInstances.set(heroElement, instance);
        }
      } catch (error) {
        console.error('[HomeHeroLogoMotion] initialization failed', error);
      }
    });
  };

  try {
    initHomeHeroMotion(document);
  } catch (error) {
    console.error('[HomeHeroLogoMotion] bootstrap failed', error);
  }

  document.addEventListener('shopify:section:load', (event) => {
    try {
      initHomeHeroMotion(event.target);
    } catch (error) {
      console.error('[HomeHeroLogoMotion] section load failed', error);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const targetElement = isElementNode(event.target) ? event.target : null;
    if (!targetElement) return;

    const heroElement = targetElement.matches('[data-home-hero]')
      ? targetElement
      : targetElement.querySelector('[data-home-hero]');
    if (!heroElement) return;
    const instance = homeHeroInstances.get(heroElement);
    if (!instance) return;
    try {
      instance.destroy();
    } catch (error) {
      console.error('[HomeHeroLogoMotion] destroy failed', error);
    }
    homeHeroInstances.delete(heroElement);
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-proof-band"] && !Shopify.designMode) return;
  try {
    
  class HomeProofBandReveal {
    constructor(sectionElement) {
      this.section = sectionElement;
      this.revealElements = Array.from(this.section?.querySelectorAll('[data-proof-reveal]') || []);
      this.prefersReducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.observer = null;
      this.onMotionPreferenceChange = this.handleMotionPreferenceChange.bind(this);

      if (!this.section || !this.revealElements.length) return;

      this.revealElements.forEach((element, index) => {
        element.style.setProperty('--proof-reveal-delay', `${Math.min(index * 120, 720)}ms`);
      });

      this.bindMotionPreferenceListener();
      this.setupObserver();
    }

    bindMotionPreferenceListener() {
      if (!this.prefersReducedMotionQuery) return;

      if (typeof this.prefersReducedMotionQuery.addEventListener == 'function') {
        this.prefersReducedMotionQuery.addEventListener('change', this.onMotionPreferenceChange);
      } else if (typeof this.prefersReducedMotionQuery.addListener == 'function') {
        this.prefersReducedMotionQuery.addListener(this.onMotionPreferenceChange);
      }
    }

    unbindMotionPreferenceListener() {
      if (!this.prefersReducedMotionQuery) return;

      if (typeof this.prefersReducedMotionQuery.removeEventListener == 'function') {
        this.prefersReducedMotionQuery.removeEventListener('change', this.onMotionPreferenceChange);
      } else if (typeof this.prefersReducedMotionQuery.removeListener == 'function') {
        this.prefersReducedMotionQuery.removeListener(this.onMotionPreferenceChange);
      }
    }

    handleMotionPreferenceChange() {
      if (this.prefersReducedMotionQuery?.matches) {
        this.revealImmediate();
        this.disconnectObserver();
        return;
      }

      if (this.section.classList.contains('is-visible')) return;
      this.setupObserver();
    }

    setupObserver() {
      if (!this.section || !this.revealElements.length) return;

      if (this.prefersReducedMotionQuery?.matches || typeof window.IntersectionObserver == 'undefined') {
        this.revealImmediate();
        return;
      }

      this.section.classList.add('has-reveal');
      this.disconnectObserver();

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.section.classList.add('is-visible');
            this.disconnectObserver();
          });
        },
        {
          threshold: 0.18,
          rootMargin: '0px 0px -10% 0px'
        }
      );

      this.observer.observe(this.section);
    }

    revealImmediate() {
      this.section.classList.remove('has-reveal');
      this.section.classList.add('is-visible');
    }

    disconnectObserver() {
      if (!this.observer) return;
      this.observer.disconnect();
      this.observer = null;
    }

    destroy() {
      this.disconnectObserver();
      this.unbindMotionPreferenceListener();
    }
  }

  const homeProofBandInstances = new WeakMap();

  const initHomeProofBands = (rootElement = document) => {
    if (rootElement.matches && rootElement.matches('[data-home-proof-band]')) {
      if (!homeProofBandInstances.has(rootElement)) {
        homeProofBandInstances.set(rootElement, new HomeProofBandReveal(rootElement));
      }
      return;
    }

    rootElement.querySelectorAll('[data-home-proof-band]').forEach((sectionElement) => {
      if (homeProofBandInstances.has(sectionElement)) return;
      homeProofBandInstances.set(sectionElement, new HomeProofBandReveal(sectionElement));
    });
  };

  initHomeProofBands(document);

  document.addEventListener('shopify:section:load', (event) => {
    initHomeProofBands(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionElement = event.target.matches('[data-home-proof-band]')
      ? event.target
      : event.target.querySelector('[data-home-proof-band]');
    if (!sectionElement) return;

    const instance = homeProofBandInstances.get(sectionElement);
    if (!instance) return;

    instance.destroy();
    homeProofBandInstances.delete(sectionElement);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-split-contact"] && !Shopify.designMode) return;
  try {
    
  class HomeSplitContactReveal {
    constructor(sectionElement) {
      this.section = sectionElement;
      this.revealElements = Array.from(this.section?.querySelectorAll('[data-split-reveal]') || []);
      this.prefersReducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.observer = null;
      this.onMotionPreferenceChange = this.handleMotionPreferenceChange.bind(this);

      if (!this.section || !this.revealElements.length) return;

      this.revealElements.forEach((element, index) => {
        element.style.setProperty('--split-reveal-delay', `${Math.min(index * 170, 700)}ms`);
      });

      this.bindMotionPreferenceListener();
      this.setupObserver();
    }

    bindMotionPreferenceListener() {
      if (!this.prefersReducedMotionQuery) return;

      if (typeof this.prefersReducedMotionQuery.addEventListener == 'function') {
        this.prefersReducedMotionQuery.addEventListener('change', this.onMotionPreferenceChange);
      } else if (typeof this.prefersReducedMotionQuery.addListener == 'function') {
        this.prefersReducedMotionQuery.addListener(this.onMotionPreferenceChange);
      }
    }

    unbindMotionPreferenceListener() {
      if (!this.prefersReducedMotionQuery) return;

      if (typeof this.prefersReducedMotionQuery.removeEventListener == 'function') {
        this.prefersReducedMotionQuery.removeEventListener('change', this.onMotionPreferenceChange);
      } else if (typeof this.prefersReducedMotionQuery.removeListener == 'function') {
        this.prefersReducedMotionQuery.removeListener(this.onMotionPreferenceChange);
      }
    }

    handleMotionPreferenceChange() {
      if (this.prefersReducedMotionQuery?.matches) {
        this.revealNow();
        this.disconnectObserver();
        return;
      }

      if (this.section.classList.contains('is-visible')) return;
      this.setupObserver();
    }

    setupObserver() {
      if (!this.section || !this.revealElements.length) return;

      if (this.prefersReducedMotionQuery?.matches || typeof window.IntersectionObserver == 'undefined') {
        this.revealNow();
        return;
      }

      this.section.classList.add('has-reveal');
      this.disconnectObserver();

      const triggerElement = this.revealElements[0] || this.section;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.revealNow();
            this.disconnectObserver();
          });
        },
        {
          threshold: 0.55,
          rootMargin: '0px 0px -12% 0px'
        }
      );

      this.observer.observe(triggerElement);
    }

    revealNow() {
      this.section.classList.add('has-reveal');
      this.section.classList.add('is-visible');
    }

    disconnectObserver() {
      if (!this.observer) return;
      this.observer.disconnect();
      this.observer = null;
    }

    destroy() {
      this.disconnectObserver();
      this.unbindMotionPreferenceListener();
    }
  }

  const homeSplitContactInstances = new WeakMap();

  const initHomeSplitContacts = (rootElement = document) => {
    if (rootElement.matches && rootElement.matches('[data-home-split-contact]')) {
      if (!homeSplitContactInstances.has(rootElement)) {
        homeSplitContactInstances.set(rootElement, new HomeSplitContactReveal(rootElement));
      }
      return;
    }

    rootElement.querySelectorAll('[data-home-split-contact]').forEach((sectionElement) => {
      if (homeSplitContactInstances.has(sectionElement)) return;
      homeSplitContactInstances.set(sectionElement, new HomeSplitContactReveal(sectionElement));
    });
  };

  initHomeSplitContacts(document);

  document.addEventListener('shopify:section:load', (event) => {
    initHomeSplitContacts(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionElement = event.target.matches('[data-home-split-contact]')
      ? event.target
      : event.target.querySelector('[data-home-split-contact]');
    if (!sectionElement) return;

    const instance = homeSplitContactInstances.get(sectionElement);
    if (!instance) return;

    instance.destroy();
    homeSplitContactInstances.delete(sectionElement);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-trust-band"] && !Shopify.designMode) return;
  try {
    
  class HomeTrustBandReveal {
    constructor(sectionElement) {
      this.section = sectionElement;
      this.items = Array.from(this.section.querySelectorAll('[data-trust-item]'));
      this.observer = null;
      this.prefersReducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionPreferenceChange = this.handleMotionPreferenceChange.bind(this);

      if (!this.section || !this.items.length) return;

      this.bindMotionPreferenceListener();
      this.setupObserver();
    }

    bindMotionPreferenceListener() {
      if (!this.prefersReducedMotionQuery) return;

      if (typeof this.prefersReducedMotionQuery.addEventListener == 'function') {
        this.prefersReducedMotionQuery.addEventListener('change', this.onMotionPreferenceChange);
      } else if (typeof this.prefersReducedMotionQuery.addListener == 'function') {
        this.prefersReducedMotionQuery.addListener(this.onMotionPreferenceChange);
      }
    }

    unbindMotionPreferenceListener() {
      if (!this.prefersReducedMotionQuery) return;

      if (typeof this.prefersReducedMotionQuery.removeEventListener == 'function') {
        this.prefersReducedMotionQuery.removeEventListener('change', this.onMotionPreferenceChange);
      } else if (typeof this.prefersReducedMotionQuery.removeListener == 'function') {
        this.prefersReducedMotionQuery.removeListener(this.onMotionPreferenceChange);
      }
    }

    handleMotionPreferenceChange() {
      if (this.prefersReducedMotionQuery?.matches) {
        this.revealAllImmediate();
        this.disconnectObserver();
        return;
      }

      if (this.items.every((item) => item.classList.contains('is-visible'))) return;
      this.setupObserver();
    }

    setupObserver() {
      if (!this.section || !this.items.length) return;

      if (this.prefersReducedMotionQuery?.matches || typeof window.IntersectionObserver == 'undefined') {
        this.revealAllImmediate();
        return;
      }

      this.disconnectObserver();

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.revealWithStagger();
            this.disconnectObserver();
          });
        },
        {
          threshold: 0.22,
          rootMargin: '0px 0px -12% 0px'
        }
      );

      this.observer.observe(this.section);
    }

    disconnectObserver() {
      if (!this.observer) return;
      this.observer.disconnect();
      this.observer = null;
    }

    revealAllImmediate() {
      this.items.forEach((item) => {
        item.style.removeProperty('--trust-reveal-delay');
        item.classList.add('is-visible');
      });
    }

    revealWithStagger() {
      this.items.forEach((item, index) => {
        const delay = Math.min(index * 150, 750);
        item.style.setProperty('--trust-reveal-delay', `${delay}ms`);
        item.classList.add('is-visible');
      });
    }

    destroy() {
      this.disconnectObserver();
      this.unbindMotionPreferenceListener();
    }
  }

  const homeTrustBandInstances = new WeakMap();

  const initHomeTrustBands = (rootElement = document) => {
    if (rootElement.matches && rootElement.matches('[data-home-trust-band]')) {
      if (!homeTrustBandInstances.has(rootElement)) {
        homeTrustBandInstances.set(rootElement, new HomeTrustBandReveal(rootElement));
      }
      return;
    }

    rootElement.querySelectorAll('[data-home-trust-band]').forEach((sectionElement) => {
      if (homeTrustBandInstances.has(sectionElement)) return;
      homeTrustBandInstances.set(sectionElement, new HomeTrustBandReveal(sectionElement));
    });
  };

  initHomeTrustBands(document);

  document.addEventListener('shopify:section:load', (event) => {
    initHomeTrustBands(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionElement = event.target.matches('[data-home-trust-band]')
      ? event.target
      : event.target.querySelector('[data-home-trust-band]');
    if (!sectionElement) return;

    const instance = homeTrustBandInstances.get(sectionElement);
    if (!instance) return;

    instance.destroy();
    homeTrustBandInstances.delete(sectionElement);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["model-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = Array.from(document.querySelectorAll('[data-model-collection-page]'));
    if (!sections.length) return;

    sections.forEach((section) => {
      const hero = section.querySelector('.model-collection-page__hero');
      if (!hero) return;

      let rafId = null;

      const updateParallax = () => {
        rafId = null;

        const rect = hero.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const maxOffset = 56;

        if (rect.bottom <= 0 || rect.top >= viewportHeight) {
          section.style.setProperty('--mcp-hero-parallax-offset', '0px');
          return;
        }

        const progress = Math.min(1, Math.max(0, (viewportHeight - rect.top) / (viewportHeight + rect.height)));
        const offset = Math.round(progress * maxOffset);
        section.style.setProperty('--mcp-hero-parallax-offset', `${offset}px`);
      };

      const requestParallaxUpdate = () => {
        if (rafId) return;
        rafId = window.requestAnimationFrame(updateParallax);
      };

      updateParallax();
      window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
      window.addEventListener('resize', requestParallaxUpdate);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class ProductRelatedProductsCarousel {
        constructor(section) {
          this.section = section;
          this.viewport = section.querySelector('[data-prp-viewport]');
          this.trackWrap = section.querySelector('[data-prp-track-wrap]');
          this.track = section.querySelector('[data-prp-track]');
          this.heading = section.querySelector('[data-prp-reveal="heading"]');
          this.reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.autoSpeed = Number.parseFloat(section.dataset.prpAutoscrollSpeed || '');
          this.autoSpeed = Number.isFinite(this.autoSpeed) && this.autoSpeed > 0 ? this.autoSpeed : 18;
          this.loopWidth = 0;
          this.originalCards = [];
          this.canLoop = false;
          this.isCentered = false;
          this.autoPosition = 0;
          this.isVisible = false;
          this.isDragging = false;
          this.pauseUntil = 0;
          this.suppressClickUntil = 0;
          this.lastTimestamp = 0;
          this.rafId = null;
        this.pointerId = null;
        this.activePointerType = null;
        this.pointerStartX = 0;
        this.pointerStartY = 0;
        this.pointerStartScrollLeft = 0;
        this.dragThreshold = 8;
        this.dragDistance = 0;

          if (!this.viewport || !this.trackWrap || !this.track) return;

          this.handlePointerDown = this.handlePointerDown.bind(this);
          this.handlePointerMove = this.handlePointerMove.bind(this);
        this.handlePointerUp = this.handlePointerUp.bind(this);
        this.handleClickCapture = this.handleClickCapture.bind(this);
        this.handleNativeDragStart = this.handleNativeDragStart.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.animateAutoScroll = this.animateAutoScroll.bind(this);

          this.setupInfiniteTrack();
          this.bindInteractions();
          this.initReveal();
          window.requestAnimationFrame(() => {
            this.handleResize();
          });
          window.setTimeout(() => {
            this.handleResize();
          }, 450);

          if (this.reduceMotion) {
            this.heading?.classList.add('is-visible');
            this.trackWrap.classList.add('is-visible');
          }
          this.startAutoScrollLoop();
        }

        bindInteractions() {
          this.viewport.addEventListener('pointerdown', this.handlePointerDown);
          this.viewport.addEventListener('pointermove', this.handlePointerMove);
          this.viewport.addEventListener('pointerup', this.handlePointerUp);
          this.viewport.addEventListener('pointercancel', this.handlePointerUp);
          this.viewport.addEventListener('lostpointercapture', this.handlePointerUp);
          this.viewport.addEventListener('click', this.handleClickCapture, true);
          this.viewport.addEventListener('dragstart', this.handleNativeDragStart);
          window.addEventListener('resize', this.handleResize);
        }

        addWindowPointerListeners() {
          window.addEventListener('pointermove', this.handlePointerMove);
          window.addEventListener('pointerup', this.handlePointerUp);
          window.addEventListener('pointercancel', this.handlePointerUp);
        }

        removeWindowPointerListeners() {
          window.removeEventListener('pointermove', this.handlePointerMove);
          window.removeEventListener('pointerup', this.handlePointerUp);
          window.removeEventListener('pointercancel', this.handlePointerUp);
        }

        setupInfiniteTrack() {
          if (!this.track || !this.viewport) return;

          this.originalCards = Array.from(this.track.children);
          this.refreshLoopMetrics();

          const hasEnoughUniqueCards = this.originalCards.length >= 3;
          const canFillViewport = this.loopWidth > this.viewport.clientWidth + 2;
          this.canLoop = hasEnoughUniqueCards && canFillViewport;

          if (!this.canLoop) {
            this.isCentered = true;
            this.trackWrap.classList.add('is-centered');
            this.viewport.classList.add('is-centered');
            this.removeLoopClones();
            this.viewport.scrollLeft = 0;
            return;
          }

          this.ensureLoopCapacity();
          this.updateLoopWidthFromDom();
          this.autoPosition = 0;
          this.viewport.scrollLeft = 0;
        }

        refreshLoopMetrics() {
          if (!this.track || !this.originalCards.length) {
            this.loopWidth = 0;
            return;
          }

          const computedStyle = window.getComputedStyle(this.track);
          const gapValue = Number.parseFloat(computedStyle.columnGap || computedStyle.gap || '0');
          const gap = Number.isFinite(gapValue) ? gapValue : 0;

          const cardsWidth = this.originalCards.reduce((sum, card) => {
            const width = card.getBoundingClientRect().width;
            return sum + (Number.isFinite(width) ? width : 0);
          }, 0);

          const setWidth = cardsWidth + gap * Math.max(0, this.originalCards.length);
          if (setWidth > 0) {
            this.loopWidth = setWidth;
          } else {
            const fallbackWidth = this.track.scrollWidth;
            this.loopWidth = Number.isFinite(fallbackWidth) ? fallbackWidth : 0;
          }
        }

        ensureLoopCapacity() {
          if (!this.track || !this.viewport || !this.originalCards.length || this.loopWidth <= 0) return;

          let guard = 0;
          while (this.track.scrollWidth < this.viewport.clientWidth + this.loopWidth * 1.1 && guard < 14) {
            const fragment = document.createDocumentFragment();
            this.originalCards.forEach((card) => {
              const clone = card.cloneNode(true);
              clone.classList.add('is-clone');
              clone.setAttribute('aria-hidden', 'true');
              clone.querySelectorAll('a, button, input, select, textarea').forEach((node) => {
                node.setAttribute('tabindex', '-1');
              });
              fragment.appendChild(clone);
            });
            this.track.appendChild(fragment);
            guard += 1;
          }

          this.updateLoopWidthFromDom();
        }

        removeLoopClones() {
          this.track?.querySelectorAll('.is-clone').forEach((clone) => clone.remove());
        }

        updateLoopWidthFromDom() {
          if (!this.track || this.originalCards.length < 2) return;

          const firstOriginal = this.track.children[0];
          const firstClone = this.track.children[this.originalCards.length];
          if (!firstOriginal || !firstClone) return;

          const measuredWidth = firstClone.offsetLeft - firstOriginal.offsetLeft;
          if (Number.isFinite(measuredWidth) && measuredWidth > 0) {
            this.loopWidth = measuredWidth;
          }
        }

        initReveal() {
          if (!('IntersectionObserver' in window) || this.reduceMotion) {
            this.heading?.classList.add('is-visible');
            this.trackWrap.classList.add('is-visible');
            this.isVisible = true;
            return;
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.target === this.heading && entry.isIntersecting) {
                  this.heading.classList.add('is-visible');
                  this.observer.unobserve(this.heading);
                }

                if (entry.target === this.trackWrap) {
                  if (entry.isIntersecting) {
                    this.trackWrap.classList.add('is-visible');
                    this.isVisible = true;
                  } else {
                    this.isVisible = false;
                  }
                }
              });
            },
            {
              threshold: 0.18
            }
          );

          if (this.heading) {
            this.observer.observe(this.heading);
          }
          this.observer.observe(this.trackWrap);
        }

        handleClickCapture(event) {
          if (performance.now() < this.suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
          }
        }

        handleNativeDragStart(event) {
          event.preventDefault();
        }

        setNormalizedScroll(value) {
          if (!this.viewport || !Number.isFinite(value)) return;

          if (this.loopWidth > 0) {
            let normalized = value % this.loopWidth;
            if (normalized < 0) normalized += this.loopWidth;
            this.autoPosition = normalized;
            this.viewport.scrollLeft = normalized;
            return;
          }

          const clamped = Math.max(0, value);
          this.autoPosition = clamped;
          this.viewport.scrollLeft = clamped;
        }

        handlePointerDown(event) {
          if (event.button !== undefined && event.button !== 0) return;
          if (!this.viewport) return;

          this.pointerId = event.pointerId;
          this.activePointerType = event.pointerType || 'mouse';
          this.pointerStartX = event.clientX;
          this.pointerStartY = event.clientY;
          this.pointerStartScrollLeft = Number.isFinite(this.autoPosition) ? this.autoPosition : this.viewport.scrollLeft;
          this.isDragging = false;
          this.dragDistance = 0;
          this.pauseUntil = performance.now() + 200;
          if (this.activePointerType === 'mouse') {
            this.addWindowPointerListeners();
          } else {
            this.viewport.setPointerCapture?.(event.pointerId);
          }
        }

        handlePointerMove(event) {
          if (this.pointerId === null || event.pointerId !== this.pointerId || !this.viewport) return;

          const deltaX = event.clientX - this.pointerStartX;
          const deltaY = event.clientY - this.pointerStartY;
          this.dragDistance = Math.max(this.dragDistance, Math.abs(deltaX));
          const threshold = Number.isFinite(this.dragThreshold) ? this.dragThreshold : 8;
          const shouldDrag = Math.abs(deltaX) > threshold && Math.abs(deltaX) > Math.abs(deltaY);

          if (!shouldDrag && !this.isDragging) return;

          if (!this.isDragging) {
            this.isDragging = true;
            this.viewport.classList.add('is-dragging');
            this.viewport.setPointerCapture?.(event.pointerId);
          }

          event.preventDefault();
          this.setNormalizedScroll(this.pointerStartScrollLeft - deltaX);
        }

        handlePointerUp(event) {
          if (this.pointerId !== null && event.pointerId !== undefined && event.pointerId !== this.pointerId) return;
          if (this.pointerId !== null && this.viewport?.hasPointerCapture?.(this.pointerId)) {
            this.viewport.releasePointerCapture(this.pointerId);
          }
          this.removeWindowPointerListeners();
          this.pointerId = null;
          this.activePointerType = null;
          this.viewport?.classList.remove('is-dragging');
          if (this.isDragging) {
            this.pauseUntil = performance.now() + 1300;
            this.suppressClickUntil = performance.now() + 420;
          }
          this.isDragging = false;
        }

        handleResize() {
          if (!this.viewport || !this.track) return;

          this.refreshLoopMetrics();
          const hasEnoughUniqueCards = this.originalCards.length >= 3;
          const canFillViewport = this.loopWidth > this.viewport.clientWidth + 2;
          const nextCanLoop = hasEnoughUniqueCards && canFillViewport;

          if (!nextCanLoop) {
            this.canLoop = false;
            this.isCentered = true;
            this.trackWrap.classList.add('is-centered');
            this.viewport.classList.add('is-centered');
            this.removeLoopClones();
            this.autoPosition = 0;
            this.viewport.scrollLeft = 0;
            return;
          }

          this.canLoop = true;
          this.isCentered = false;
          this.trackWrap.classList.remove('is-centered');
          this.viewport.classList.remove('is-centered');
          this.ensureLoopCapacity();
          this.updateLoopWidthFromDom();
          const current = Number.isFinite(this.autoPosition) ? this.autoPosition : this.viewport.scrollLeft || 0;
          this.setNormalizedScroll(current);
        }

        startAutoScrollLoop() {
          if (this.rafId || this.autoSpeed <= 0) return;
          this.lastTimestamp = performance.now();
          this.rafId = window.requestAnimationFrame(this.animateAutoScroll);
        }

        shouldAutoScroll(timestamp) {
          if (!this.viewport || !this.isVisible || this.isCentered || !this.canLoop) return false;
          if (this.isDragging || this.pointerId !== null) return false;
          if (timestamp < this.pauseUntil) return false;

          if (this.loopWidth > 2) {
            return this.viewport.scrollWidth - this.viewport.clientWidth > 2;
          }

          const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
          return maxScroll > 2;
        }

        animateAutoScroll(timestamp) {
          if (!this.viewport) return;
          const deltaMs = Math.min(24, Math.max(0, timestamp - this.lastTimestamp));
          this.lastTimestamp = timestamp;

          if (this.shouldAutoScroll(timestamp)) {
            const distance = (this.autoSpeed * deltaMs) / 1000;
            if (this.loopWidth > 0) {
              this.setNormalizedScroll(this.autoPosition + distance);
            } else {
              const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
              let nextPosition = this.autoPosition + distance;
              if (nextPosition >= maxScroll) {
                nextPosition = 0;
              }
              this.setNormalizedScroll(nextPosition);
            }
          }

          this.rafId = window.requestAnimationFrame(this.animateAutoScroll);
        }

        destroy() {
          this.observer?.disconnect();
          if (this.rafId) {
            window.cancelAnimationFrame(this.rafId);
            this.rafId = null;
          }

          if (!this.viewport) return;
          this.viewport.removeEventListener('pointerdown', this.handlePointerDown);
          this.viewport.removeEventListener('pointermove', this.handlePointerMove);
          this.viewport.removeEventListener('pointerup', this.handlePointerUp);
          this.viewport.removeEventListener('pointercancel', this.handlePointerUp);
          this.viewport.removeEventListener('lostpointercapture', this.handlePointerUp);
          this.viewport.removeEventListener('click', this.handleClickCapture, true);
          this.viewport.removeEventListener('dragstart', this.handleNativeDragStart);
          this.removeWindowPointerListeners();
          window.removeEventListener('resize', this.handleResize);
        }
      }

      const state =
        window.__productRelatedProductsCarouselState ||
        (window.__productRelatedProductsCarouselState = {
          instances: new WeakMap(),
          listenersBound: false,
          init: null,
          unload: null
        });

      const init = (root = document) => {
        const sections = root.querySelectorAll?.('[data-prp-section]') || [];
        sections.forEach((section) => {
          if (state.instances.has(section)) return;
          state.instances.set(section, new ProductRelatedProductsCarousel(section));
        });
      };

      const unload = (root = document) => {
        const section = root.matches?.('[data-prp-section]') ? root : root.querySelector?.('[data-prp-section]');
        if (!section) return;
        const instance = state.instances.get(section);
        if (!instance) return;
        instance.destroy();
        state.instances.delete(section);
      };

      state.init = init;
      state.unload = unload;

      if (!state.listenersBound) {
        document.addEventListener('shopify:section:load', (event) => {
          window.__productRelatedProductsCarouselState?.init?.(event.target);
        });
        document.addEventListener('shopify:section:unload', (event) => {
          window.__productRelatedProductsCarouselState?.unload?.(event.target);
        });
        document.addEventListener('DOMContentLoaded', () => {
          window.__productRelatedProductsCarouselState?.init?.(document);
        });
        window.addEventListener('load', () => {
          window.__productRelatedProductsCarouselState?.init?.(document);
          window.setTimeout(() => {
            window.__productRelatedProductsCarouselState?.init?.(document);
          }, 500);
        });
        state.listenersBound = true;
      }

    init(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsCarouselSection {
    constructor(section) {
      this.section = section;
      this.viewport = section.querySelector('[data-testimonials-viewport]');
      this.track = section.querySelector('[data-testimonials-track]');
      this.originalCards = Array.from(section.querySelectorAll('[data-testimonials-card]'));
      this.cards = [];
      this.prevButton = section.querySelector('[data-testimonials-prev]');
      this.nextButton = section.querySelector('[data-testimonials-next]');
      this.expandedIndexes = new Set();
      this.pointerId = null;
      this.pointerStartX = 0;
      this.pointerStartY = 0;
      this.pointerStartScrollLeft = 0;
      this.isDragging = false;
      this.dragDistance = 0;
      this.dragThreshold = 8;
      this.activeIndex = 0;
      this.activePhysicalIndex = 0;
      this.middleStartIndex = 0;
      this.scrollRaf = null;
      this.suppressClickUntil = 0;
      this.loopWidth = 0;
      this.logicalCount = this.originalCards.length;
      this.animationFrame = null;
      this.scrollEndTimer = null;

      if (!this.viewport || !this.track || this.originalCards.length === 0) return;

      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handlePrev = this.handlePrev.bind(this);
      this.handleNext = this.handleNext.bind(this);
      this.handlePointerDown = this.handlePointerDown.bind(this);
      this.handlePointerMove = this.handlePointerMove.bind(this);
      this.handlePointerUp = this.handlePointerUp.bind(this);
      this.handleClickCapture = this.handleClickCapture.bind(this);
      this.handleReviewToggle = this.handleReviewToggle.bind(this);

      this.bind();
      this.setupInfiniteTrack();
      this.setInitialSlide();
      this.updateActiveCard();
      this.updateButtons();
    }

    bind() {
      this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
      this.viewport.addEventListener('pointerdown', this.handlePointerDown);
      this.viewport.addEventListener('pointermove', this.handlePointerMove);
      this.viewport.addEventListener('pointerup', this.handlePointerUp);
      this.viewport.addEventListener('pointercancel', this.handlePointerUp);
      this.viewport.addEventListener('lostpointercapture', this.handlePointerUp);
      this.viewport.addEventListener('click', this.handleClickCapture, true);
      this.section.addEventListener('click', this.handleReviewToggle);
      this.viewport.addEventListener('dragstart', (event) => event.preventDefault());
      this.prevButton?.addEventListener('click', this.handlePrev);
      this.nextButton?.addEventListener('click', this.handleNext);
      window.addEventListener('resize', this.handleResize);
    }

    setupInfiniteTrack() {
      if (!this.track || this.originalCards.length < 2) {
        this.cards = Array.from(this.track?.querySelectorAll('[data-testimonials-card]') || []);
        this.middleStartIndex = 0;
        return;
      }

      const prependFragment = document.createDocumentFragment();
      const appendFragment = document.createDocumentFragment();

      this.originalCards.forEach((card) => {
        const appendClone = card.cloneNode(true);
        appendClone.classList.add('is-clone');
        appendClone.setAttribute('aria-hidden', 'true');
        appendClone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
        appendFragment.appendChild(appendClone);
      });

      [...this.originalCards].reverse().forEach((card) => {
        const prependClone = card.cloneNode(true);
        prependClone.classList.add('is-clone');
        prependClone.setAttribute('aria-hidden', 'true');
        prependClone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
        prependFragment.insertBefore(prependClone, prependFragment.firstChild);
      });

      this.track.prepend(prependFragment);
      this.track.append(appendFragment);
      this.cards = Array.from(this.track.querySelectorAll('[data-testimonials-card]'));
      this.middleStartIndex = this.logicalCount;
      this.refreshLoopMetrics();
    }

    refreshLoopMetrics() {
      if (!this.track || this.originalCards.length < 2) {
        this.loopWidth = 0;
        return;
      }

      const firstOriginal = this.track.children[this.logicalCount];
      const firstAppendedClone = this.track.children[this.logicalCount * 2];
      if (!firstOriginal || !firstAppendedClone) {
        this.loopWidth = 0;
        return;
      }

      const measuredWidth = firstAppendedClone.offsetLeft - firstOriginal.offsetLeft;
      this.loopWidth = Number.isFinite(measuredWidth) && measuredWidth > 0 ? measuredWidth : 0;
    }

    addWindowPointerListeners() {
      window.addEventListener('pointermove', this.handlePointerMove);
      window.addEventListener('pointerup', this.handlePointerUp);
      window.addEventListener('pointercancel', this.handlePointerUp);
    }

    removeWindowPointerListeners() {
      window.removeEventListener('pointermove', this.handlePointerMove);
      window.removeEventListener('pointerup', this.handlePointerUp);
      window.removeEventListener('pointercancel', this.handlePointerUp);
    }

    setInitialSlide() {
      const initialIndex = this.logicalCount > 2 ? 1 : 0;
      const initialPhysicalIndex = this.middleStartIndex + initialIndex;
      window.requestAnimationFrame(() => {
        this.scrollToPhysicalIndex(initialPhysicalIndex, 'auto');
      });
    }

    getTargetScrollForCard(card) {
      if (!this.viewport || !card) return 0;
      return card.offsetLeft - ((this.viewport.clientWidth - card.offsetWidth) / 2);
    }

    scrollToPhysicalIndex(index, behavior = 'smooth') {
      if (!this.viewport || !this.cards.length) return;

      const safePhysicalIndex = Math.max(0, Math.min(index, this.cards.length - 1));
      const targetCard = this.cards[safePhysicalIndex];
      if (!targetCard) return;

      this.activePhysicalIndex = safePhysicalIndex;
      this.activeIndex = this.getWrappedIndex(Number(targetCard.dataset.testimonialsIndex) || 0);
      const target = this.getTargetScrollForCard(targetCard);
      if (behavior === 'smooth') {
        this.animateScrollTo(target);
      } else {
        this.stopScrollAnimation();
        this.viewport.scrollLeft = target;
        this.recenterToMiddleSet();
      }
      this.updateActiveCard();
      this.updateButtons();
    }

    getWrappedIndex(index) {
      if (!this.logicalCount) return 0;
      const total = this.logicalCount;
      return ((index % total) + total) % total;
    }

    stopScrollAnimation() {
      if (!this.animationFrame) return;
      window.cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }

    animateScrollTo(target) {
      if (!this.viewport) return;

      this.stopScrollAnimation();

      const start = this.viewport.scrollLeft;
      const distance = target - start;

      if (Math.abs(distance) < 1) {
        this.viewport.scrollLeft = target;
        return;
      }

      const duration = 360;
      const startTime = performance.now();
      const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

      const step = (now) => {
        if (!this.viewport) {
          this.animationFrame = null;
          return;
        }

        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        this.viewport.scrollLeft = start + (distance * easeOutCubic(progress));
        this.queueActiveUpdate();

        if (progress < 1) {
          this.animationFrame = window.requestAnimationFrame(step);
        } else {
          this.viewport.scrollLeft = target;
          this.animationFrame = null;
          this.recenterToMiddleSet();
          this.updateActiveCard();
        }
      };

      this.animationFrame = window.requestAnimationFrame(step);
    }

    updateActiveCard() {
      if (!this.viewport || !this.cards.length) return;

      const viewportCenter = this.viewport.scrollLeft + (this.viewport.clientWidth / 2);
      let closestIndex = 0;
      let closestPhysicalIndex = 0;
      let closestCard = null;
      let closestDistance = Number.POSITIVE_INFINITY;

      this.cards.forEach((card, index) => {
        const cardCenter = card.offsetLeft + (card.offsetWidth / 2);
        const distance = Math.abs(cardCenter - viewportCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestCard = card;
          closestPhysicalIndex = index;
          closestIndex = Number(card.dataset.testimonialsIndex ?? index);
        }
      });

      this.activePhysicalIndex = closestPhysicalIndex;
      this.activeIndex = this.getWrappedIndex(closestIndex);
      const normalizedPhysicalIndex = this.getNormalizedPhysicalIndex(closestPhysicalIndex);
      this.cards.forEach((card, cardIndex) => {
        card.classList.toggle(
          'is-active',
          cardIndex === closestPhysicalIndex || cardIndex === normalizedPhysicalIndex
        );
      });
      this.updateButtons();
    }

    updateButtons() {
      const isSingleCard = this.logicalCount <= 1;
      if (this.prevButton) this.prevButton.disabled = isSingleCard;
      if (this.nextButton) this.nextButton.disabled = isSingleCard;
    }

    getNormalizedPhysicalIndex(index) {
      if (this.logicalCount < 2) return index;

      let normalizedPhysicalIndex = index;

      if (normalizedPhysicalIndex < this.middleStartIndex) {
        normalizedPhysicalIndex += this.logicalCount;
      } else if (normalizedPhysicalIndex >= this.middleStartIndex + this.logicalCount) {
        normalizedPhysicalIndex -= this.logicalCount;
      }

      return normalizedPhysicalIndex;
    }

    recenterToMiddleSet() {
      if (!this.viewport || this.logicalCount < 2 || !this.cards.length) return;

      const normalizedPhysicalIndex = this.getNormalizedPhysicalIndex(this.activePhysicalIndex);
      if (normalizedPhysicalIndex === this.activePhysicalIndex) return;

      const normalizedCard = this.cards[normalizedPhysicalIndex];
      if (!normalizedCard) return;

      this.activePhysicalIndex = normalizedPhysicalIndex;
      this.viewport.scrollLeft = this.getTargetScrollForCard(normalizedCard);
    }

    queueActiveUpdate() {
      if (this.scrollRaf) return;
      this.scrollRaf = window.requestAnimationFrame(() => {
        this.scrollRaf = null;
        this.updateActiveCard();
      });
    }

    handleScroll() {
      this.queueActiveUpdate();
      if (this.scrollEndTimer) {
        window.clearTimeout(this.scrollEndTimer);
      }
      if (this.isDragging || this.pointerId !== null) return;
      this.scrollEndTimer = window.setTimeout(() => {
        this.scrollEndTimer = null;
        this.snapToNearest();
      }, 140);
    }

    handleResize() {
      this.stopScrollAnimation();
      this.refreshLoopMetrics();
      this.scrollToPhysicalIndex(this.activePhysicalIndex, 'auto');
    }

    handlePrev() {
      this.scrollToPhysicalIndex(this.activePhysicalIndex - 1);
    }

    handleNext() {
      this.scrollToPhysicalIndex(this.activePhysicalIndex + 1);
    }

    handlePointerDown(event) {
      if (event.button !== undefined && event.button !== 0) return;
      if (!this.viewport) return;
      if ((event.pointerType || 'mouse') !== 'mouse') return;

      this.pointerId = event.pointerId;
      this.pointerStartX = event.clientX;
      this.pointerStartY = event.clientY;
      this.pointerStartScrollLeft = this.viewport.scrollLeft;
      this.isDragging = false;
      this.dragDistance = 0;
      this.addWindowPointerListeners();

      this.stopScrollAnimation();
    }

    handlePointerMove(event) {
      if (this.pointerId === null || event.pointerId !== this.pointerId || !this.viewport) return;

      const deltaX = event.clientX - this.pointerStartX;
      const deltaY = event.clientY - this.pointerStartY;
      this.dragDistance = Math.max(this.dragDistance, Math.abs(deltaX));
      const shouldDrag = Math.abs(deltaX) > this.dragThreshold && Math.abs(deltaX) > Math.abs(deltaY);

      if (!shouldDrag && !this.isDragging) return;

      if (!this.isDragging) {
        this.isDragging = true;
        this.viewport.classList.add('is-dragging');
        this.viewport.setPointerCapture?.(event.pointerId);
      }

      event.preventDefault();
      this.viewport.scrollLeft = this.pointerStartScrollLeft - deltaX;
      this.queueActiveUpdate();
    }

    handlePointerUp(event) {
      if (this.pointerId !== null && event.pointerId !== undefined && event.pointerId !== this.pointerId) return;
      if (this.pointerId !== null && this.viewport?.hasPointerCapture?.(this.pointerId)) {
        this.viewport.releasePointerCapture(this.pointerId);
      }

      this.removeWindowPointerListeners();
      this.pointerId = null;
      this.viewport?.classList.remove('is-dragging');

      if (this.isDragging) {
        this.suppressClickUntil = performance.now() + 420;
        this.snapToNearest();
      }

      this.isDragging = false;
    }

    handleClickCapture(event) {
      if (performance.now() < this.suppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    setExpandedState(index, expanded) {
      if (expanded) {
        this.expandedIndexes.add(index);
      } else {
        this.expandedIndexes.delete(index);
      }

      this.cards.forEach((card) => {
        const cardIndex = Number(card.dataset.testimonialsIndex);
        if (cardIndex !== index) return;
        card.classList.toggle('is-expanded', expanded);
        card.querySelectorAll('[data-review-toggle="expand"]').forEach((button) => {
          button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
        card.querySelectorAll('[data-review-toggle="collapse"]').forEach((button) => {
          button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
      });
    }

    handleReviewToggle(event) {
      const toggle = event.target.closest('[data-review-toggle]');
      if (!toggle || !this.section.contains(toggle)) return;

      event.preventDefault();
      event.stopPropagation();

      const card = toggle.closest('[data-testimonials-card]');
      if (!card) return;

      const cardIndex = Number(card.dataset.testimonialsIndex);
      if (!Number.isFinite(cardIndex)) return;

      const action = toggle.getAttribute('data-review-toggle');
      this.setExpandedState(cardIndex, action === 'expand');
    }

    snapToNearest() {
      this.updateActiveCard();
      this.scrollToPhysicalIndex(this.activePhysicalIndex);
    }

    destroy() {
      this.stopScrollAnimation();
      if (this.scrollRaf) {
        window.cancelAnimationFrame(this.scrollRaf);
        this.scrollRaf = null;
      }
      if (this.scrollEndTimer) {
        window.clearTimeout(this.scrollEndTimer);
        this.scrollEndTimer = null;
      }
      this.removeWindowPointerListeners();
      this.viewport?.removeEventListener('scroll', this.handleScroll);
      this.viewport?.removeEventListener('pointerdown', this.handlePointerDown);
      this.viewport?.removeEventListener('pointermove', this.handlePointerMove);
      this.viewport?.removeEventListener('pointerup', this.handlePointerUp);
      this.viewport?.removeEventListener('pointercancel', this.handlePointerUp);
      this.viewport?.removeEventListener('lostpointercapture', this.handlePointerUp);
      this.viewport?.removeEventListener('click', this.handleClickCapture, true);
      this.section.removeEventListener('click', this.handleReviewToggle);
      this.prevButton?.removeEventListener('click', this.handlePrev);
      this.nextButton?.removeEventListener('click', this.handleNext);
      window.removeEventListener('resize', this.handleResize);
    }
  }

  const state =
    window.__testimonialsCarouselState ||
    (window.__testimonialsCarouselState = {
      instances: new WeakMap(),
      init: null,
      unload: null,
      listenersBound: false
    });

  const init = (root = document) => {
    const sections = root.querySelectorAll?.('[data-testimonials-carousel]') || [];
    sections.forEach((section) => {
      if (state.instances.has(section)) return;
      state.instances.set(section, new TestimonialsCarouselSection(section));
    });
  };

  const unload = (root = document) => {
    const section = root.matches?.('[data-testimonials-carousel]') ? root : root.querySelector?.('[data-testimonials-carousel]');
    if (!section) return;
    const instance = state.instances.get(section);
    if (!instance) return;
    instance.destroy();
    state.instances.delete(section);
  };

  state.init = init;
  state.unload = unload;

  if (!state.listenersBound) {
    document.addEventListener('shopify:section:load', (event) => {
      window.__testimonialsCarouselState?.init?.(event.target);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      window.__testimonialsCarouselState?.unload?.(event.target);
    });
    document.addEventListener('DOMContentLoaded', () => {
      window.__testimonialsCarouselState?.init?.(document);
    });
    window.addEventListener('load', () => {
      window.__testimonialsCarouselState?.init?.(document);
      window.setTimeout(() => {
        window.__testimonialsCarouselState?.init?.(document);
      }, 500);
    });
    state.listenersBound = true;
  }

  init(document);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tuning-guides-page"] && !Shopify.designMode) return;
  try {
    
  class TuningGuidesPage {
    constructor(sectionElement) {
      this.section = sectionElement;
      this.links = Array.from(this.section.querySelectorAll('[data-guide-brand-link]'));
      this.rotatorTimers = [];
      this.boundLinkHandlers = [];

      if (this.links.length) {
        this.setupAnchorLinks();
      }

      this.setupLogoRotators();
    }

    setupAnchorLinks() {
      this.links.forEach((link) => {
        const handler = (event) => {
          const href = link.getAttribute('href');
          if (!href || !href.startsWith('#')) return;

          const target = this.section.querySelector(href);
          if (!target) return;

          event.preventDefault();

          const header = document.querySelector('.site-header');
          const headerOffset = header ? header.offsetHeight : 0;
          const extraOffset = 28;
          const targetTop = target.getBoundingClientRect().top + window.scrollY - headerOffset - extraOffset;

          window.scrollTo({
            top: Math.max(targetTop, 0),
            behavior: 'smooth'
          });
        };

        this.boundLinkHandlers.push({ link, handler });
        link.addEventListener('click', handler);
      });
    }

    setupLogoRotators() {
      const rotators = Array.from(this.section.querySelectorAll('[data-guide-logo-rotator]'));

      rotators.forEach((rotator) => {
        if (rotator.dataset.rotating !== 'true') return;

        const frames = Array.from(rotator.querySelectorAll('[data-guide-logo-frame]'));
        if (frames.length < 2) return;

        let currentIndex = 0;
        const stepDuration = Number.parseInt(
          getComputedStyle(this.section).getPropertyValue('--tg-brand-logo-step-duration'),
          10
        );
        const duration = Number.isFinite(stepDuration) ? stepDuration : 3400;

        frames.forEach((frame, frameIndex) => {
          frame.classList.toggle('is-active', frameIndex === 0);
        });

        const timer = window.setInterval(() => {
          frames[currentIndex].classList.remove('is-active');
          currentIndex = (currentIndex + 1) % frames.length;
          frames[currentIndex].classList.add('is-active');
        }, duration);

        this.rotatorTimers.push(timer);
      });
    }

    destroy() {
      this.boundLinkHandlers.forEach(({ link, handler }) => {
        link.removeEventListener('click', handler);
      });
      this.boundLinkHandlers = [];

      this.rotatorTimers.forEach((timer) => {
        window.clearInterval(timer);
      });
      this.rotatorTimers = [];
    }
  }

  const tuningGuidesPageInstances = new WeakMap();

  const initTuningGuidesPages = (root = document) => {
    if (!root || typeof root.querySelectorAll !== 'function') return;

    if (root.matches && root.matches('[data-tuning-guides-page]')) {
      if (!tuningGuidesPageInstances.has(root)) {
        tuningGuidesPageInstances.set(root, new TuningGuidesPage(root));
      }
      return;
    }

    root.querySelectorAll('[data-tuning-guides-page]').forEach((section) => {
      if (tuningGuidesPageInstances.has(section)) return;
      tuningGuidesPageInstances.set(section, new TuningGuidesPage(section));
    });
  };

  initTuningGuidesPages(document);

  document.addEventListener('shopify:section:load', (event) => {
    initTuningGuidesPages(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches && event.target.matches('[data-tuning-guides-page]')
      ? event.target
      : event.target.querySelector && event.target.querySelector('[data-tuning-guides-page]');

    if (!section) return;

    const instance = tuningGuidesPageInstances.get(section);
    if (!instance) return;
    instance.destroy();
    tuningGuidesPageInstances.delete(section);
  });

  } catch(e) { console.error(e); }
})();
})();
